import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/myedibleenso.github.io/myedibleenso.github.io/src/components/BasicLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#overview",
        "aria-label": "overview permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Overview`}</h1>
    <p>{`This tutorial provides instructions for installing the latest Ubuntu LTS (Long Term Support) version using VirtualBox.`}</p>
    <p><strong parentName="p">{`At the time of this writing, the current LTS is 24.04.`}</strong></p>
    <p><undefined parentName="p">{`
        `}<div {...{
          "className": "embedVideo-container"
        }}>{`
            `}<iframe parentName="div" {...{
            "title": "",
            "width": 800,
            "height": 400,
            "src": "https://www.youtube-nocookie.com/embed/r69nbRM28sI?rel=0",
            "className": "embedVideo-iframe",
            "style": {
              "border": "0"
            },
            "loading": "eager",
            "allowFullScreen": true,
            "sandbox": "allow-same-origin allow-scripts allow-popups"
          }}></iframe>{`
        `}</div></undefined></p>
    <div {...{
      "className": "admonition admonition-note alert alert--secondary"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M6.3 5.69a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 7.99c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V7.98v.01zM7 2.3c-3.14 0-5.7 2.54-5.7 5.68 0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 .98c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z"
              }}></path></svg></span>{`Video covers older installation  `}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`Note that the video linked above covers an older LTS, so the user interface of both VirtualBox and Ubuntu will differ from the most recent release.`}</p></div></div>
    <h2 {...{
      "id": "outcomes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#outcomes",
        "aria-label": "outcomes permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Outcomes`}</h2>
    <ul>
      <li parentName="ul">{`Produce a working installation (virtual machine) of Ubuntu LTS`}</li>
    </ul>
    <h2 {...{
      "id": "prerequisites",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#prerequisites",
        "aria-label": "prerequisites permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`A computer with 6GB+ of RAM `}<a parentName="li" {...{
          "href": "https://www.virtualbox.org/manual/ch01.html#hostossupport",
          "target": "_self",
          "rel": "nofollow"
        }}>{`running an OS that is compatible with VirtualBox`}</a>{` and an AMD64 or ARM64 CPU.`}</li>
    </ul>
    <h3 {...{
      "id": "important-note",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#important-note",
        "aria-label": "important note permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Important note`}</h3>
    <div {...{
      "className": "admonition admonition-note alert alert--secondary"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M6.3 5.69a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 7.99c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V7.98v.01zM7 2.3c-3.14 0-5.7 2.54-5.7 5.68 0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 .98c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z"
              }}></path></svg></span>{`A note to ARM64 users `}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`Recent versions of VirtualBox now support ARM64 CPU architecture (ex. a Mac M series); however, `}<strong parentName="p">{`if you're on a Mac, you can install Docker Desktop directly and execute the provided commands in the terminal to follow along in the course.`}</strong>{`  `}<a parentName="p" {...{
            "href": "https://support.apple.com/en-us/HT211814",
            "target": "_self",
            "rel": "nofollow"
          }}>{`If you're unsure if your Mac has an ARM64 CPU, see this article from Apple`}</a>{`.  Note the CLI commands used throughout the course tutorials will not work as-is in Windows PowerShell. `}<strong parentName="p">{`Windows users should install Ubuntu`}</strong>{` (either via VirtualBox or natively `}<a parentName="p" {...{
            "href": "https://ubuntu.com/tutorials/install-ubuntu-desktop#6-type-of-installation",
            "target": "_self",
            "rel": "nofollow"
          }}>{`on a separate partition`}</a>{`). An alternative for Windows users is to use the `}<a parentName="p" {...{
            "href": "https://learn.microsoft.com/en-us/windows/wsl/install",
            "target": "_self",
            "rel": "nofollow"
          }}>{`Windows Subsystem for Linux (WSL)`}</a><undefined parentName="p">{`.  Installation and configuration using WSL is not a route that is currently covered in this tutorial, so proceed at your own peril `}<span {...{
              "role": "img",
              "aria-label": "mage"
            }}>{`🧙`}</span>{`.`}</undefined></p></div></div>
    <h1 {...{
      "id": "background",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#background",
        "aria-label": "background permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Background`}</h1>
    <p>{`This section provides a bit of background on the key technologies involved in this tutorial.`}</p>
    <h2 {...{
      "id": "whats-linux",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#whats-linux",
        "aria-label": "whats linux permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h2">{`What's Linux?`}</em></h2>
    <p>{`Linux is a common core or `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Kernel_(operating_system)",
        "target": "_self",
        "rel": "nofollow"
      }}><em parentName="a">{`kernel`}</em></a>{` shared by a class of `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Operating_system",
        "target": "_self",
        "rel": "nofollow"
      }}>{`operating systems`}</a>{` (OS).  Commonly, however, people simply use `}<em parentName="p">{`Linux`}</em>{` to refer to operating systems that use the Linux kernel.`}</p>
    <h3 {...{
      "id": "historylineage",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#historylineage",
        "aria-label": "historylineage permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`History/Lineage`}</h3>
    <p>{`Linux was developed by `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Linus_Torvalds",
        "target": "_self",
        "rel": "nofollow"
      }}>{`Linus Torvalds`}</a>{` in the 1990s as an extension to the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/GNU",
        "target": "_self",
        "rel": "nofollow"
      }}>{`GNU operating system`}</a>{` (which in turn was a rewrite of AT&T's Unix OS). `}</p>
    <h2 {...{
      "id": "whats-virtualbox",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#whats-virtualbox",
        "aria-label": "whats virtualbox permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h2">{`What's VirtualBox?`}</em></h2>
    <p>{`VirtualBox is a free, `}<a parentName="p" {...{
        "href": "https://www.virtualbox.org/manual/ch01.html#hostossupport",
        "target": "_self",
        "rel": "nofollow"
      }}>{`cross-platform (AMD64 CPUs running MacOS, Windows, Linux, etc.)`}</a>{` application for software virtualization that allows you to run multiple `}<em parentName="p">{`guest`}</em>{` operating systems (virtual machines) at the same time on a single `}<em parentName="p">{`host`}</em>{` OS (the OS of the physical machine on which VirtualBox is running).  If something goes wrong with a virtual machine (for example, perhaps you're experimenting with a completely new OS), you can safely delete or replace it without damaging your host OS.`}</p>
    <h2 {...{
      "id": "why-use-linux",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#why-use-linux",
        "aria-label": "why use linux permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h2">{`Why use Linux?`}</em></h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Highly customizable`}</strong>{`: Unlike operating systems such as Window or MacOS, the `}<em parentName="p">{`core`}</em>{` of a Linux OS is open-source software (OSS) making it highly customizable.  `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Democratized access`}</strong>{`: Most Linux distributions are free and some Linux distributions are `}<em parentName="p">{`completely`}</em>{` open source!`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Fast and lightweight`}</strong>{`: Linux distributions can be barebones. Some have no graphical interface at all (these are typically labeled as server distributions). As such, they typically run faster than commercial alternatives.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Common in the developer world`}</strong>{`: While you may not see many computers sold with a Linux distribution preinstalled at large retailers, Linux distributions are quite common.  `}<a parentName="p" {...{
            "href": "https://en.wikipedia.org/wiki/Linux-powered_device",
            "target": "_self",
            "rel": "nofollow"
          }}>{`Many devices`}</a>{` such as TVs and e-readers are powered by Linux.  `}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.omgubuntu.co.uk/2017/11/linux-now-powers-100-worlds-top-500-supercomputers",
              "target": "_self",
              "rel": "nofollow"
            }}>{`Most (if not all) of the world's supercomputers run a version of Linux`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://phys.org/news/2013-05-international-space-station-laptop-migration.html",
              "target": "_self",
              "rel": "nofollow"
            }}>{`Linux has been adopted by major space programs`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://en.wikipedia.org/wiki/Red_Star_OS",
              "target": "_self",
              "rel": "nofollow"
            }}>{`North Korea has its own Linux distribution`}</a></li>
          <li parentName="ul">{`Linux is fairly ubiquitious on large cloud computing providers `}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://en.wikipedia.org/wiki/List_of_Linux_adopters",
              "target": "_self",
              "rel": "nofollow"
            }}>{`Here are some of the other places Linux is used`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "why-is-this-necessary",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#why-is-this-necessary",
        "aria-label": "why is this necessary permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h2">{`Why is this necessary?`}</em></h2>
    <p>{`Many of the tools we will use were developed on Linux-based OS.  `}<strong parentName="p">{`This course uses a Linux-based development environment`}</strong>{`. For the sake of uniformity, we'll be using the latest `}<a parentName="p" {...{
        "href": "https://ubuntu.com/about",
        "target": "_self",
        "rel": "nofollow"
      }}>{`Ubuntu`}</a>{` Desktop LTS which is a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Debian",
        "target": "_self",
        "rel": "nofollow"
      }}>{`Debian-based Linux distribution`}</a>{`.`}</p>
    <h1 {...{
      "id": "prerequisites-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#prerequisites-1",
        "aria-label": "prerequisites 1 permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Prerequisites`}</h1>
    <p>{`Before starting, ensure that ...`}</p>
    <ul>
      <li parentName="ul">{`you have a machine with at least 8GB of RAM and 50GB of free space`}</li>
    </ul>
    <h2 {...{
      "id": "part-1-installing-virtualbox",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#part-1-installing-virtualbox",
        "aria-label": "part 1 installing virtualbox permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Part 1: Installing VirtualBox`}</h2>
    <p>{`Follow `}<a parentName="p" {...{
        "href": "https://www.virtualbox.org/wiki/Downloads",
        "target": "_self",
        "rel": "nofollow"
      }}>{`this link`}</a>{` and install VirtualBox according to the instructions provided for your operating system (OS).`}</p>
    <h3 {...{
      "id": "checking-the-version-of-virtualbox",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#checking-the-version-of-virtualbox",
        "aria-label": "checking the version of virtualbox permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Checking the version of VirtualBox`}</h3>
    <ol>
      <li parentName="ol">{`Click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`VirtualBox`}</code>{` `}{`→`}{` `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`About VirtualBox`}</code>{`.  You can check the version in the window that launches.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7bad3228fbcd38c6a3bb6330e43070da/d4e7f/virtualbox-version.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "81.08108108108108%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAABYlAAAWJQFJUiTwAAAD30lEQVQ4y1WTS28TVxzFzxAKJi9ADk3lVIlTiAPEhJpgkaJWqEkW5SUhQqEpNIU8yKtJHHv8tkksB8eO38ExhBTcACkLYIFUIVXtouoXqPolms6GVVfFM6eaGVeCxU/nzr1XZ/6vC1NdzfaTFvNod1uLz97aJNpbm9x2s0mjq8Xk7j7Q7P7s0H73SYtZQ917B7NJ7DKbPF1m09zRD99vhKH1gHHfV6P/GAfGWNs/xOqLN1h3aUij/tIQGwbG2Hhtkvu+HtfYe3mkwrDOlxX6r7O+93wfhINHjPCubGF+jQ2JjX+b0pvl3bEfyvWxUtkQ/b6MQLGM4FuE7laofAcKb+C/U4Y7+wZXZ3qw41CnEXPLUnWowGP5J7It90Sxph8pqpoW7ytwpRTBk1XgyShwv4WYVuBKKnAuK5hLEDMxBZfHewDLESPEtARPjnClZThThJjRcWcIT5YIFonQPSJQ1PEXCF+e8Gap/yhNzXhgqhdotxnhzkrw5ghvTha8eQre3LvMrxPh+xSCqukqBX+egi9LwZuh4ElXDBP/G3Ya4c5Lgm+F8ORkLSo1Opd6KamvA/cIb0Hf085XCFHNKEc4M2raxOySgisTvai12owQc9IHsRIHf3wpfxu6Qnv2Ac9v/MTP157Rmn9KW/EF9y7cZUf6Mc8VH9IXPkObe4ZtosgWp1fBbJyYiiroH+1FVbvVCG9B2hYs8ubzn+XRzWe05Z5w5MWvHH7+C889fsWJl7/xm6evmPr9Dw4+fExf6AvOBc/SFTzNq97LCqaXiMmIboi2w0b4ViW12DXhVXl3ZF1rxHZfjtvUugYKrAkXWB/Ms86f404xyXpnhAZHlDWzEVZNRxVhKkqMRxRcHFENO4zwFyW16HBnZYhpvbNiSlf/CvUaxYnpmDoexHSc+C5GTC4SE1FF07EFBReGewFLhxGhNQmREuG/I2smauHVhqgRquPhXKbgiLPWk9ZxJ1ntTLB2LsFqR1zB2AIxGlZwYahiOL++hduPqL0AMSXDlZQxl5Dhy8vwZGQ44vI2x5Jsz2zIx5IPZXuyJJ9IleTuVEk+enutfCC8ohgmIjLODvYABzsbEC29RnyTiDzQU3UldQ0WqM2YQ30JS9zlUiNbpsGRoMERp2Emxl2zS2y6VWDtbIw4fa0PaG7dg+Dqn7i19hrB1S1ML0qYWJA0dcYlTEUkjIUljAQlDAckDAUk3PBLuO6TMOiRcMP39x5XTNp5M/AX+i59AgACuj5thv1UO46fasPRbgs6jlvQecKira12Cw53aVRZ7Todxy1VHV2aCu0fW9D4kQXNB/e/t69xx3/LbzKduBDHtQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "virtualbox-version",
            "title": "virtualbox-version",
            "src": "/static/7bad3228fbcd38c6a3bb6330e43070da/fcda8/virtualbox-version.png",
            "srcSet": ["/static/7bad3228fbcd38c6a3bb6330e43070da/12f09/virtualbox-version.png 148w", "/static/7bad3228fbcd38c6a3bb6330e43070da/e4a3f/virtualbox-version.png 295w", "/static/7bad3228fbcd38c6a3bb6330e43070da/fcda8/virtualbox-version.png 590w", "/static/7bad3228fbcd38c6a3bb6330e43070da/efc66/virtualbox-version.png 885w", "/static/7bad3228fbcd38c6a3bb6330e43070da/c83ae/virtualbox-version.png 1180w", "/static/7bad3228fbcd38c6a3bb6330e43070da/d4e7f/virtualbox-version.png 1416w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    {/* [Download the latest Ubuntu LTS (Long Term Support release) for your CPU architecture (AMD64 vs ARM64)](https://cdimage.ubuntu.com/noble/daily-live/current/) */}
    <h2 {...{
      "id": "part-2-downloading-ubuntu-lts",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#part-2-downloading-ubuntu-lts",
        "aria-label": "part 2 downloading ubuntu lts permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Part 2: Downloading Ubuntu LTS`}</h2>
    <ol>
      <li parentName="ol">{`Open the `}<a parentName="li" {...{
          "href": "https://cdimage.ubuntu.com/noble/daily-live/current/",
          "target": "_self",
          "rel": "nofollow"
        }}>{`Ubuntu Desktop LTS (Long Term Support) release page`}</a>{` in your computer's web browser. You can download the Ubuntu disk image (also known as an ISO file) here. `}</li>
    </ol>
    <div {...{
      "className": "admonition admonition-warning alert alert--danger"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "12",
              "height": "16",
              "viewBox": "0 0 12 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M5.05.31c.81 2.17.41 3.38-.52 4.31C3.55 5.67 1.98 6.45.9 7.98c-1.45 2.05-1.7 6.53 3.53 7.7-2.2-1.16-2.67-4.52-.3-6.61-.61 2.03.53 3.33 1.94 2.86 1.39-.47 2.3.53 2.27 1.67-.02.78-.31 1.44-1.13 1.81 3.42-.59 4.78-3.42 4.78-5.56 0-2.84-2.53-3.22-1.25-5.61-1.52.13-2.03 1.13-1.89 2.75.09 1.08-1.02 1.8-1.86 1.33-.67-.41-.66-1.19-.06-1.78C8.18 5.31 8.68 2.45 5.05.32L5.03.3l.02.01z"
              }}></path></svg></span>{`Check your platform version  `}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`Be sure to select the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`.iso`}</code>{` file for the appropriate platform architecture for your machine (AMD64 or ARM64). AMD64 will have the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`-amd64.iso`}</code>{` suffix, while ARM64 will use the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`-arm64.iso`}</code>{` suffix.`}</p></div></div>
    <p>{`Alternatively, you can use one of the following links: `}</p>
    <ul>
      <li parentName="ul">{`AMD64: `}<a parentName="li" {...{
          "href": "https://public.parsertongue.org/ubuntu/ubuntu-lts-amd64.iso",
          "target": "_self",
          "rel": "nofollow"
        }}>{`https://public.parsertongue.org/ubuntu/ubuntu-lts-amd64.iso`}</a></li>
      <li parentName="ul">{`ARM64: `}<a parentName="li" {...{
          "href": "https://public.parsertongue.org/ubuntu/ubuntu-lts-arm64.iso",
          "target": "_self",
          "rel": "nofollow"
        }}>{`https://public.parsertongue.org/ubuntu/ubuntu-lts-arm64.iso`}</a></li>
    </ul>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`After confirming that the platform architecture of your ISO file,  click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Download`}</code>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/143940731846b821a556447f1e285348/0560f/ubuntu-download.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.1891891891892%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC10lEQVQ4y3WR2WsTURTG5//QFx+KWrRbbF1a7RJrBRcEFVQQVEQfXChSKKI+iA/qU7W41DAWHShYCi60TQkICvrgW0UkbWoak4mtmUwmyUySO8uZmU9mWm2L7YHfvdzDud8597tcQ2vwWqC9c6S+Nfhia3ObUNPcKmzfu18ItHUKdbs7fJr3HxZ27Tso1LV0+DS1dwl1ze1C7c42oXZHq9DQEnwRaOkYqdu5p4ebFPo/RF8NIDo8gEnhAb48u4uvQh++Dz9BdOSpT+xNCLG3IURfDyD6LoTpsUFMjT3H1PggpsLPMR15iZn3Q/g2PviJyxxZN6oeXY/CsfWGemoDlc5uJO1MFWnnN5F2YRNpl6pJu1xNpe4tVOnZSpXeWqrcDBC7vZ3YnW2k32si42HQsB53Qe3rnOBSx6vC0okqZE5WkXR6M7LnapA9twXyhVpkL9Yge6ke8pV6yN0NyPUEoPRug3K9EcqNRii3Aijcb0ex/yBpjw5B6jsQ4cqpH2FHEmFLIlm/k9B/zcKcS8CYm4UtpRbILiJ7iAvkRNhKGk5hDnZhnlw1g4qUjHA62WEsBBm2g1xRRbHMUCxXsDzcZawS5C26SRGOVSphuC5c1yHHJpRLJR/HtuHnHdunqGrI5QtQCkVomubX6IzBdRz/rtdKZyzCMcb+TWhZFubn55HJZCBJko8sy2CMIa+qyMg5ZHMK5HwBTNdhmiYcX9BdmFDXVwratg1VVf3OhmF4BT5e3iKCbhgwTBOmZS1Z4b9uDUHDslAolaFqGtRi0Rcvl8ve6P+5tyi0quDoYoFhmibllDwpPgrl83kqVRiVDJMssslxXbIdx9/dlRieBmNsgjNN8+Pfrp4fhkUrZrFdgNylHyZnjX8GPE8/c/F4/Go6nR5Kp9OhWCzGf5+e4afjCV4UU3xKFPmfiQSfmJ3lk8mffDKZ5EVR5FOp1D+8syiKIU8jHo93/wHR/miSW2wzxQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ubuntu-download",
            "title": "ubuntu-download",
            "src": "/static/143940731846b821a556447f1e285348/fcda8/ubuntu-download.png",
            "srcSet": ["/static/143940731846b821a556447f1e285348/12f09/ubuntu-download.png 148w", "/static/143940731846b821a556447f1e285348/e4a3f/ubuntu-download.png 295w", "/static/143940731846b821a556447f1e285348/fcda8/ubuntu-download.png 590w", "/static/143940731846b821a556447f1e285348/efc66/ubuntu-download.png 885w", "/static/143940731846b821a556447f1e285348/c83ae/ubuntu-download.png 1180w", "/static/143940731846b821a556447f1e285348/0560f/ubuntu-download.png 3160w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "part-3-creating-a-virtual-machine-vm-using-virtualbox",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#part-3-creating-a-virtual-machine-vm-using-virtualbox",
        "aria-label": "part 3 creating a virtual machine vm using virtualbox permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Part 3: Creating a virtual machine (VM) using VirtualBox`}</h2>
    <ol>
      <li parentName="ol">{`Open VirtualBox (instructions vary depending on your host OS).  If it's your first time opening VirtualBox, select the `}<strong parentName="li">{`Basic`}</strong>{` mode.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/668c6/virtualbox-select-basic-mode.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92.56756756756756%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAABYlAAAWJQFJUiTwAAAEHUlEQVQ4y6WU32scVRTHh9Lm16bUgtjurlE6aTGb3Zm5M/fOnZn9vdkkm539nexOmk2btKFgq/gk+iT4orYWFYt98sUiIog/QPRJUPooCOKLj10o/gEudgXBzHzlzrZpBX3Rhw+HGWY+99xzz7kSAGnbTkQz1snTxomTMo0XZG6a8lOnEnI+Y8uy0ZSXiCY3HV1udzpy1rFly6SyzU3Z5uw+5mmHm3Nn5uVDkjSZOtZbKf646tV9y3V/y7rKyDbZqLqcH3FujS5u5EY1zxutrHujpXxuZFvWyGR0xBl7wD1usj8YpXflU6fmJenwY/FSrXW37O2CdzeQ6SwgbVFstYvQdIq9BkGxsw5W7UBLLkI3DOi6HkZKKaihg1IdmkbuRaNRXZIkKV52a3fW1tbgrqzs16vtwK3Xg0azE1QqlSBFzIDqRsAMPTAMGhi6iEZACAkWEwvBM0myn1BMEKL9Go1GSSisuo1BuVKHXmz6vNwAK3fAy23QUhOqXYLqLEFJr0CnHIYhstFgpx1ceelVXH3jsv/sFkNS1YdPRk8Q6cjEZDyTSQ94bgln8j1/IbeOhUIPC4UuFKsUCohBoRsUhmGEqJqCq+9+gHc+u4VXbnb9nz51cWHPG0rSISJNR2bjtsUHVjoHLbvmk+wakpkaFtMuFp1VqE4ZJFuBYedh6DqUlIJCqYgvv/kZr9+6hr3rXf+L29/jtes3h5IkEWl2djbOOR+USiXUOp5vLPdAlj3kXA8ZdwuV+joarTZa7XWsrq7CcRxQRvHR59/iux/u4r1PPva/vj3A9sXLY+HMzEzcsqxBNpNBcWnZN6wsKGOwOYVtUnCTgTEKRilM0wTnHIqiYK3RwtUbH+LG+1/5l557EYqqDqPRGJGmpqbitm0PLMtCKpn0NVWBpqrigxBV00AI+RtU1DGVhJJMQFWSfjKxAKKqw3gs9nDLhUIBzWbTd10XjUbjgGq1Gh4EYyzMUmS/YjFcqFdxxdvAC/1N/9J6C5ul/DBxbOahMJ/Po9/v+5ubm+j1evA8D91uFxsbG2KhUN5qtSD6Ne04cKtV9Lpd9M+e9dutFpZKxeHjx4+PhaKGQtjtdn0h6nQ64c8i21qthnq9HiKyzWaz49ZRtbCWqVTKV8flGUbFliORyPhQslkh8YWo3W6jUqkgl8uhWCyGUSAWFYiRE1I6xhfPhJBhOClHjx49aJvz58/v9/v9YGdnJ9je3g62traCc+fOhezu7gae5wWO44RjJ8ZP13WBL+QHwunp6bhtWXdEf3HO/+Sc+6ZpHsAY88U7AaXUvy94lP37wvEsT01MxO1c4RfRNto/tMijhLfMv6Bp2u8PLofZp+X55+fm5t6OxWLXYrHYm/+Bt2Kx2MuRSOQJ6fDEpJAekiTpyP9EOKS/AGzZJrXzwMA8AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "virtualbox-basic-mode",
            "title": "virtualbox-basic-mode",
            "src": "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/fcda8/virtualbox-select-basic-mode.png",
            "srcSet": ["/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/12f09/virtualbox-select-basic-mode.png 148w", "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/e4a3f/virtualbox-select-basic-mode.png 295w", "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/fcda8/virtualbox-select-basic-mode.png 590w", "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/efc66/virtualbox-select-basic-mode.png 885w", "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/c83ae/virtualbox-select-basic-mode.png 1180w", "/static/9c94c28c3c529e2c98ecbe4cc99ad6f3/668c6/virtualbox-select-basic-mode.png 1692w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create a new virtual machine (VM)`}</strong>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d630618345488c85c1de2469803381e1/668c6/virtualbox-create-new-vm.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92.56756756756756%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAABYlAAAWJQFJUiTwAAADOUlEQVQ4y72Uy4scRRzHiyXJzu4O6MnY066yvREzj+6uRz+qp2dmd947szOZR3ZH1z1oFsGoR9GT4EXdGFQM5uTFICKIDxA9CUqOgiBePGZIyB/gYFoQ3O6v9OwsGAhiEvDwoaqg6kPVr75VBADZlWnFdx8+xU8qmlDXNMe2tUdX0lrJl5rGz2gVampnPKb1BwOt4EnNtYUmHVuTjjXDPuU59vLjq9ocIfO5B7br6z83Rp3Qbbd/L7T1QNpW0KqVAsdxg3Nni8HmaBTUh6OgUioG0nUD2xKBY1lH3HJs609LiBvaysoqIcceVMubvRvV0TNwts7CH5yG7wrs9NdhMoG9LsX6YAirNYCZzYBxDsbYtBVCQHAGIRhMk95SFIURQohabW9ea25soFWrHXRavai92Yk63X7UbDSiHLUjwXhkcRZxLiLO4pZHlNIokz4dPZGlB2ndBqXmb4qi0Klwo90Z1za6sOvD0GsOIJvb8JpbcGoDGLICw6tAz9fBhAPO492YkHkPL7zyOvbfOh8+v2Mha7DJI8pJSo7PJ1Q/nx/LUg3p6m6YrTyJbO1p5KpPgfl1cM5BuQDjYtqPMUwd++9/hPe+uILXLm+Fv3zewrN7owkhc5QsLCVV6TpjJ1+E4TdDs9BExm8jnW8hI+swvCpooQkuS+CMQc/pWCuv4+vvfsWbVy5g7+JW+NXVH/HGxcsTQgglyWRSdRxnXC6X0RmMQl7bBq2NUGyP4Ld30OwM0e310esP0Wg04HkehCXwyZff44efruODzz4Nv706xu6584fCxcVF1XXdccH3sVaphdzxIYQF1xZTbEvAEofYtg3HcaDrOWx0e9i/9DEuffhN+NyLL8MwjImipChJJBKqlHLsui5Mwwg5o9NY0BnsDsR11HUdhpEDpUaYy2bii5ooqX8IpZTx5PCo8P9GLI0zeNjnYXwiSulkGpt7EfJZsGfj6Zr7E96+2/9XeBA/K8bY3XC7cGFhQZXSvTYT/jWryd1wMBMevuXE/AlVFtduxrGhlN4xJv8F0zT/OPocko9pqy8tLy+/qyjKhVQq9fY98E4qlXp1aWnpIXLsxHwsnSOEHL9PYgf5G1u2E4uVBxvyAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "create-new-vm",
            "title": "create-new-vm",
            "src": "/static/d630618345488c85c1de2469803381e1/fcda8/virtualbox-create-new-vm.png",
            "srcSet": ["/static/d630618345488c85c1de2469803381e1/12f09/virtualbox-create-new-vm.png 148w", "/static/d630618345488c85c1de2469803381e1/e4a3f/virtualbox-create-new-vm.png 295w", "/static/d630618345488c85c1de2469803381e1/fcda8/virtualbox-create-new-vm.png 590w", "/static/d630618345488c85c1de2469803381e1/efc66/virtualbox-create-new-vm.png 885w", "/static/d630618345488c85c1de2469803381e1/c83ae/virtualbox-create-new-vm.png 1180w", "/static/d630618345488c85c1de2469803381e1/668c6/virtualbox-create-new-vm.png 1692w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Enter a name for your virtual machine. Since we're installing an Ubuntu LTS, I'll enter 'ubuntu-hlt'. Note that VirtualBox automatically changes `}<em parentName="li">{`OS`}</em>{` to `}<strong parentName="li">{`Linux`}</strong>{` and `}<em parentName="li">{`OS Distribution`}</em>{` to `}<strong parentName="li">{`Ubuntu`}</strong>{`. These two options are what we need, so keep those settings. Note that the value of OS Version will depend on your CPU architecture (ex. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Ubuntu (ARM/AMD 64-bit)`}</code>{`).  In the `}<em parentName="li">{`ISO Image`}</em>{` dropdown, select the Ubuntu LST `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.iso`}</code>{` file that you downloaded in the previous step.  Click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Continue`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2db054aa2180956101f8ff0dba80cbbb/2cb21/virtualbox-vm-name-and-os.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.08108108108109%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACtUlEQVQoz53OXUvbYBTA8QcdTnYxX8asuLYqalurzftbkyZtYqttYpNWYWxsu5gTh4y5TdBZQbGoTBvn1b7OvsCuLYx9AZmXw1FY4nNGo2Owy138+D8HzoEHjaGhLktjtxmRPCWmyAbPcC7PsS7PMi7HMq4kCO6MrruFGcOVJdHlWdYVec4V/mqIPPdR4Ln9eCzWjzpR54CsST/nnDyYjgFihofiXBHmLQtKpVJQx3ECqqoCy7LXGAaYG+2ZpmmIRqMU6rrTHdqtb583To5hubb/603ttTdT1L1cTveymurJacmTRMGTRNETeN6jKcpLTU97FEl4JHGNIlOYIonLB+EohaJDI6HDw/r3rfoOVNf2rhqNE/x8+SmesyycKy9gvTCLVSMfUHIGnqIYnEgReDSWwKPxSTw6PoHHWAVSktoavt9DofhwLFTb2bxYq63C+521q6MPB7Dycgky2SxwRhGkgglSwQoq5EsgzBSB1WdhWs5ek1RMGSUgRaUVud/X/mE0tLO3e7GxtwG1+vbV8VEDVlaXIWvosFCtQLVSAccuQ8WxoeI4gWrFgYVqFRarDpSrD3HZqYAqEK2egSiFenvvhk4P1i/Wlx5Dff3F1Sd3Cz9beoK1nI7tchkvLC5i27axaZrYNK0bZsAyS7g4X8FMpgAUkWqFoyMU6u6+HdrfNM8b7/Lgbha8t6+KviCnfY4X/Ln5sm/btm+aZiCfz/uqqvqapgXUTMbX1IwvSmkgCeIyHIlQCKFbg4qm/rDKeTBmc0DzaaBpBhiWBVU3QFEUECUJ0uk0yLIc9M+7TVQNSGc04DgWwpEIgxBC/YqsfCZJ5tv4WOwsOTnZTCaTzXYT8Vgznkg0E/+Ix+PBDkPTzVHt0Rmdtb7qmvKl797ABEKoowMh1IsQGkQIhf5T+7YfIdT5G719QCMpZE8UAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "virtualbox-vm-name-and-os",
            "title": "virtualbox-vm-name-and-os",
            "src": "/static/2db054aa2180956101f8ff0dba80cbbb/fcda8/virtualbox-vm-name-and-os.png",
            "srcSet": ["/static/2db054aa2180956101f8ff0dba80cbbb/12f09/virtualbox-vm-name-and-os.png 148w", "/static/2db054aa2180956101f8ff0dba80cbbb/e4a3f/virtualbox-vm-name-and-os.png 295w", "/static/2db054aa2180956101f8ff0dba80cbbb/fcda8/virtualbox-vm-name-and-os.png 590w", "/static/2db054aa2180956101f8ff0dba80cbbb/efc66/virtualbox-vm-name-and-os.png 885w", "/static/2db054aa2180956101f8ff0dba80cbbb/c83ae/virtualbox-vm-name-and-os.png 1180w", "/static/2db054aa2180956101f8ff0dba80cbbb/2cb21/virtualbox-vm-name-and-os.png 2174w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Select the amount of RAM to use for the virtual machine (VM). Click and drag the slider left or right to decrease or increase the amount of RAM, number of CPUs, and disk space that VirtualBox will make available to your Ubuntu VM. Click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Continue`}</code>{`.`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`The "ideal" amount of RAM will automatically be selected when you get to this page.`}</li>
    </ul>
    <div {...{
      "className": "admonition admonition-warning alert alert--danger"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "12",
              "height": "16",
              "viewBox": "0 0 12 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M5.05.31c.81 2.17.41 3.38-.52 4.31C3.55 5.67 1.98 6.45.9 7.98c-1.45 2.05-1.7 6.53 3.53 7.7-2.2-1.16-2.67-4.52-.3-6.61-.61 2.03.53 3.33 1.94 2.86 1.39-.47 2.3.53 2.27 1.67-.02.78-.31 1.44-1.13 1.81 3.42-.59 4.78-3.42 4.78-5.56 0-2.84-2.53-3.22-1.25-5.61-1.52.13-2.03 1.13-1.89 2.75.09 1.08-1.02 1.8-1.86 1.33-.67-.41-.66-1.19-.06-1.78C8.18 5.31 8.68 2.45 5.05.32L5.03.3l.02.01z"
              }}></path></svg></span>{`Don't max out your resources`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`Make sure `}<strong parentName="p">{`not`}</strong>{` to maximize the values for these fields, as the host machine (your computer) also needs resources.  If you allocate too large a percentage of your system resources to your VM, your host machine will perform sluggishly (or grow nonresponsive) while your VM is running.`}</p></div></div>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {}
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "590px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/2cb21/virtualbox-vm-resources.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.08108108108109%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACYElEQVQoz52S0WoTQRSGD63U4oW0VZqQxlSobU2E7MzuzOxsNrtZYqwmbaiCXlSQahVRrFULrSaQ0tAW22ztjc/jC3jdgPgCxV5KJWCSPTJpKArtjRcf/8w5c37mHwbGINI37Rpl3dT2kje0GtcNnzPD54buM536lin83M2sP5XL+SkpfWbo3f4xgrOaKfgnwdnG5MT4EPRC73DKlb9uz+awMJtF6QjM5/NYKOSxWCyi53koOEcpJZpCIOcchRCdmlLDMJBSgpQQHI3FCPRd6A+tVcsHtd0dfFba+P2m9Lp5936xOTNTbLqu28FxnGY6nT7BcdyO2rbd5Jw3pZSBrutHkUiEQCxyNbS1Vf3xoVrBe0vrbb+2Gzx6PBdIywosywqEEAGlVA38g6opo1QqFUhpIWOsEQ6HCUyOToRKldXDpdJLfF9Zau983MRXiy/Q8TLoOE4noop1GirysaFU+0b3hrFQZX3tcGV9BUvVcnt7ewefPn+CmWy2Y2iaZmeYdVFrZcAYQ8EY8nQmEFMzSKTdiF4eJDAwcDG0t7l8uLwwh9Xlhfbn3XLwYH4+4EIEgvOAc34SWenfa9VT5wjVkVDaiI6MEOjvPx/aWC0c1N7l0F+91Xy7eKclLNmihLYoJS1K6ZkQQlpUS7Z0SlDTtKNoNEoA4FzYdp2f08UcZqc8pFyiTvUz302hd1V9I2KmkZkWcsYwGr2iAwAM2Sn7i6bp36+NTewn4vF6IpGox+PxU1G96/F4PZlM1jOZTH3Me7ivezPfPNf+OnhpeBwAenoAYAAAwgAQ+k/U7BAA9P4Bp1g2VR5OhRQAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="a" {...{
              "className": "gatsby-resp-image-image",
              "alt": "virtualbox-vm-resources",
              "title": "Try to allocate at least 4GB of RAM to your VM and 50 GB of storage.",
              "src": "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/fcda8/virtualbox-vm-resources.png",
              "srcSet": ["/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/12f09/virtualbox-vm-resources.png 148w", "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/e4a3f/virtualbox-vm-resources.png 295w", "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/fcda8/virtualbox-vm-resources.png 590w", "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/efc66/virtualbox-vm-resources.png 885w", "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/c83ae/virtualbox-vm-resources.png 1180w", "/static/d1c4ff0f1cd5b34b8ecd97ea5a6aacc0/2cb21/virtualbox-vm-resources.png 2174w"],
              "sizes": "(max-width: 590px) 100vw, 590px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Try to allocate at least 4GB of RAM to your VM and 50 GB of storage.`}</figcaption>{`
  `}</figure></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Review the values and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Finish`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c1e9ef6225ab0f8f665138ec2c6c446e/e7aec/virtualbox-vm-settings.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "90.54054054054053%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAABYlAAAWJQFJUiTwAAADXElEQVQ4y52TT2/jRBjGTcUCByr1vJQ2bhWy7fjveMb/HTuJE8d20sQkEbQSSJzQCg6cuHLjG3CDb7ARh72hwA0JIY58FZBXWH7RO6QtCLYHLD2akTXzm+d55x3pm8qTFtx4PPDPNOOtx8SWB6Sr2OTtnkc408gonJCUlaScZSTPMuK5DnFsTlyHE9fey7E11+bHnzz9WBLfLAm+zVcFuNXVb27xpJ7GrF6Mzdpzozot+nW68uokSuok6decs5oxVnMhq2bM+p0zBtQ0v5ck6TXkvR6M5z8MFzdgr99vvZkB+SiAdeGB44QQJDaEBQNqWEAtCyilYBoGmKYp5pTSllILNE37RZKkQwEMJ/kurT6AzUef/pF99nWbPP2qvXzvy3Zwdd2W86rtx9M2SgZtGA9bx49aarHWNM1W07RWVdVGVVW4vLz8+Q44yae7SbkEFo0bc1QBTRagxwvIrzYwHo+BcQ6DwQB83wPKOKyvP4Sbm2soigLVLJdLiOP4HjhIs91gOAJNIQ3VFTA1BaihQZyOcSEEvg+j0Qh834cwDODdagmu50EQBHBxcdH0ej2YzWb3QMb5znVdMCltsB6iThaDabWCqqogDEMhjOY4DkynUzg+PoZutwuHh4fNwcEBpGl6D7Rte+d5Hha6EbB9wfOihOFwCKM0hfl8DowxIYxqWZZYh3swRVEULwdSXGgxSMsKZmUJ6J5zLiIiyN+XAA8bDocNjrZtP+BwD52XBazXaxERXWw2GwHWNE3EVxQF1eD4j1v+d2RD3OZksYJ5WQK3bREVHeq6LmAoBGua1uA/RVEeiExFbWCSF7BarSDLMuEQY2IbTSYTMWJ013UbdP2gQ4xrmBTicQbTLBM1/KtlQuHydsQbt227QfeEkJcCxSswKW2z8qotiqJN07QNw1C8DEVR8HWI+V7/EZnz79CFYZovEIoyqNWk+bzJp9PG9/0miiKhfr/fYExd12/1AoGEkJ/ugI4f/OgHgeg9bAsUtRjk8ysoywLiJIEoisQNozDivgfvpKrqr7fAV7tE/fyd3pPnstx5JstnW1mWt2eyvDV0fcs536qquqWUbs/Pz7cnJyfbTqfzdz3rdDrPT09Pv5Ak6Q3JTAuEPpIk6c39Cf9HuPfR0dHRK38CtmfjsBpSQXUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "virtualbox-vm-settings",
            "title": "virtualbox-vm-settings",
            "src": "/static/c1e9ef6225ab0f8f665138ec2c6c446e/fcda8/virtualbox-vm-settings.png",
            "srcSet": ["/static/c1e9ef6225ab0f8f665138ec2c6c446e/12f09/virtualbox-vm-settings.png 148w", "/static/c1e9ef6225ab0f8f665138ec2c6c446e/e4a3f/virtualbox-vm-settings.png 295w", "/static/c1e9ef6225ab0f8f665138ec2c6c446e/fcda8/virtualbox-vm-settings.png 590w", "/static/c1e9ef6225ab0f8f665138ec2c6c446e/efc66/virtualbox-vm-settings.png 885w", "/static/c1e9ef6225ab0f8f665138ec2c6c446e/c83ae/virtualbox-vm-settings.png 1180w", "/static/c1e9ef6225ab0f8f665138ec2c6c446e/e7aec/virtualbox-vm-settings.png 1726w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <div {...{
      "className": "admonition admonition-note alert alert--secondary"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M6.3 5.69a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 7.99c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V7.98v.01zM7 2.3c-3.14 0-5.7 2.54-5.7 5.68 0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 .98c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z"
              }}></path></svg></span>{`Need to adjust resources?`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`If you'd like to adjust your system resource allocations, you can do so by clicking `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`Settings`}</code>{` -> `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`System`}</code>{`.`}</p></div></div>
    <h2 {...{
      "id": "part-4-installing-ubuntu-in-virtualbox",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#part-4-installing-ubuntu-in-virtualbox",
        "aria-label": "part 4 installing ubuntu in virtualbox permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Part 4: Installing Ubuntu in VirtualBox`}</h2>
    <p>{`Now that the virtual machine has been created, we are ready to install Ubuntu in this VM. `}</p>
    <ol {...{
      "start": 0
    }}>
      <li parentName="ol">{`Select your new VM created in Part 3 and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Start`}</code>{` . `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4fd1d7f918571426e2d8ae93e8ec29cf/e7aec/virtualbox-vm-start.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "90.54054054054053%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAABYlAAAWJQFJUiTwAAADXklEQVQ4y52TTW/jRBjHTcUCByr1vFRt3Cpk2/HbjGf8nthJ7Pgtb24SQSux0p7QCg6cuHLjG3CDb7ARh72hwA0JIY58FZBXWH7QDGkLgu0BS3/NaDT+zf//zDPSN5UrLZjxeOidacZ7j5ElD1FXsdBJz0WUaij3Y3RlZmg2TVGepsh1bGRbDDk2Q461l21pjsWOP3n+sSS+aeR/m68KcKr5b07xpM5CWi8SXHtOUM9zv55f2XUWDOowCmvGaE0prZmQWVNq/s4oBYLx95IkvcV5b/vJ7IfR4gas9YetOzUgH/uwKlxw7QDikMKgoODrGLBpAiEEsGEAxljMCSEtISZomvaLJEmHAhhM8l1cfQSbZ5/+kX72dRs9/6q9/ODLdji/bq+mizYbJO0wilo/HLW212+JSVuMcatpWquqaqOqKlxeXv58B5zk2W5SLoH2kwaPKyDRAvRwAfl8A3GSAGEMouEQPM8FQhmsr5/Czc01FEXB1SyXSwjD8B44jNPdcDQGTUEN0RXAmgLE0CCME4jCEHzPg/F4DJ7nQRD4cFUtwXFd8H0fLi4uml6vB9Pp9B5IGds5jgOYkIbXQ9TJpJBVK6iqCoIgEOLRbNuGLMvg+PgYut0uHB4eNgcHBxDH8T3Qsqyd67q80I2A7QueFyWMRiMYxzHMZjOglArxqKZpin38nzAM+drrgYRvNCnEZQXTsgTunjEmInKQty8BP2w0GjV8tCzrAYd76KwsYL1ei4jcxWazEWBN00R8RVG4Gj7+45b/HdkQtzlZrGBWlsAsS0TlDnVdFzAuDtY0reFriqI8EJmI2sAkL2C1WkGapsIhj5kkCUwmEzHy6I7jNNz1gw55XAMTCJMUsjQVNfyrZQLh8nbkN25ZVsPdI4ReCxSvABPSpuW8LYqijeO4DYJAvAxFUfjrEPO9/iMyY99xFwbGrziUyyBmE+ezJs+yxvO8pt/vCw0Gg4bH1HX9Vq84ECH00x3Q9vwfPd8XvcfbgouYFPLZHMqygDCKoN/vixvm4hH3PXgnVVV/vQW+2UXq5+/3nryU5c4LWT7byrK8PZPlraHrW8bYVlXVLSFke35+vj05Odl2Op2/60Wn03l5enr6hSRJ70g4Ljj0kSRJ7+5P+D/i/z46Ojp640/XNOPot6gCYQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "virtualbox-vm-start",
            "title": "virtualbox-vm-start",
            "src": "/static/4fd1d7f918571426e2d8ae93e8ec29cf/fcda8/virtualbox-vm-start.png",
            "srcSet": ["/static/4fd1d7f918571426e2d8ae93e8ec29cf/12f09/virtualbox-vm-start.png 148w", "/static/4fd1d7f918571426e2d8ae93e8ec29cf/e4a3f/virtualbox-vm-start.png 295w", "/static/4fd1d7f918571426e2d8ae93e8ec29cf/fcda8/virtualbox-vm-start.png 590w", "/static/4fd1d7f918571426e2d8ae93e8ec29cf/efc66/virtualbox-vm-start.png 885w", "/static/4fd1d7f918571426e2d8ae93e8ec29cf/c83ae/virtualbox-vm-start.png 1180w", "/static/4fd1d7f918571426e2d8ae93e8ec29cf/e7aec/virtualbox-vm-start.png 1726w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <div {...{
      "className": "admonition admonition-note alert alert--secondary"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M6.3 5.69a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 7.99c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V7.98v.01zM7 2.3c-3.14 0-5.7 2.54-5.7 5.68 0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 .98c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z"
              }}></path></svg></span>{`Look a little different?`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`The installation process that follows may differ a little from version to version. The screenshots here are based on `}<strong parentName="p">{`Ubuntu 24.04`}</strong>{`. `}</p></div></div>
    <ol>
      <li parentName="ol">{`Using the arrow keys, select, `}<strong parentName="li">{`Try or Install Ubuntu`}</strong>{` and hit `}<strong parentName="li">{`Enter`}</strong>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f73371fb6f157f3c9738d032de2b2526/d50e7/vm-install-1-try-or-install.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.89189189189189%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB5ElEQVQ4y7WSXW/aMBSGjxMQH4Y4wXY+UJsACYEENIY0VCQ0db1bxR2/h/tK3LXq3+wlKWrTnMnWhKZddNW0WXp0fF5Zr885NkhqDwPPebId62QzdrRtVjBmFZbVLZhlFYHvF/1+UPSDoJBCnPUOpUU4iot8NjtOs+y0WHx6isPLIRg1M+/1+MvFxSX2+30MggDDMMTRaKTJshzTNMXxeIzjND3rURThfPEZv93c4Nfra/yyWr343MkBAKbL5fJ5s9ngarV6W6/X1Xw+r8IwrAaDgY5RFJ1R2nA41Posz6vvt7dv2+0Wr67Wz7TTmYKUMmu1WicAQEJIpeJHYYypytUFGMfxyXXdDDzPy9rt9unnobMhIeRd1BnOOU4mkyqOY0yS5H3Dj6AM0zT9z4a+7/9bQ9u2taFhGGiaZmWaJtZqtT+i5iil1DNMkkQbqgcGQsiUEHJ0XbfyPO+Vc146jlPatl0KIUrGWNnpdMper6dzpTcaDY3v+2Wapq9Jkqgqj5zzqfqHeb1eR8dxdAvdbhdbrZaGUortdltHlTebTdXF+ZWFEKpC9WU0nPMcDMOQhJA7AHgEgHsAeCCEaH7d/66pSCl9cF33XgjxKKW8o5RKEEKotuFv1n6/B0TUHA4H2O128AN0yQiwIhQH/AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-1-try-or-install",
            "title": "vm-install-1-try-or-install",
            "src": "/static/f73371fb6f157f3c9738d032de2b2526/fcda8/vm-install-1-try-or-install.png",
            "srcSet": ["/static/f73371fb6f157f3c9738d032de2b2526/12f09/vm-install-1-try-or-install.png 148w", "/static/f73371fb6f157f3c9738d032de2b2526/e4a3f/vm-install-1-try-or-install.png 295w", "/static/f73371fb6f157f3c9738d032de2b2526/fcda8/vm-install-1-try-or-install.png 590w", "/static/f73371fb6f157f3c9738d032de2b2526/efc66/vm-install-1-try-or-install.png 885w", "/static/f73371fb6f157f3c9738d032de2b2526/c83ae/vm-install-1-try-or-install.png 1180w", "/static/f73371fb6f157f3c9738d032de2b2526/d50e7/vm-install-1-try-or-install.png 2280w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Select your preferred language and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c2e37dbce239c1c7cc955665ff68de0d/0c1ff/vm-install-2-select-language.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC7klEQVQ4y5WRy28bVRSHD62apm8QSuK0TezanhnP0x4/Y5uUOLS4JEgZINMHFWSDxBI2LNiwAkuIBfs20BUSjax0LNEsQhGCXSX+EBZFUdz4Mb5z7w95RkRQsWiP9OlIR0ffOedeytrZW5qp7caT8e1YbMYbM3PItDd7ftZLSykvlU56sdkZbzo2HfVMT3nx5CVPyWQ8SUo/0E1jR9cyFdJeTnyrnLgA9eQ8rqhVNLU6VvRFvG28Dsdq4B1rGa59FTfyb+JmvolbhSaaZh2r2UVcKy8jZ+dhWzkUCwUUdO02GUcufqnSFN6TGkMx4iwYjBgfMMaHjIlhEOZht8f8pwMGPwgZ9YcMANvearOlpQZzXddvNJZhZrR1yh1LtAyK4bp2ddwk8BzBRdTmdTqo1WricrXOq/kiTEl1qTiRbOXpAm7rzVAouADnPEQIgYAx7O3tobvfRbfbDeuMsVDY6XRQLpWELme4mkxDT8su1Sbl1gLFsWGuRELx3yXHgl6vfzggHBIEh8JKuSxyusk1SYaSTLl0+YTaWqQUPrJWo5Mf76D7eBdPDgYY9vvjEWCDKP8TzwrzuskNSYGaSrt07UyudeWlDD621yLh/l8YPPkT+08P4Pt+KPL7PQjOI9v/bFg0LJ6VM9DTkks3Xq211o8X8EnJjU5+9gM4x8FB71Dy75O9jhcKK4bF84oKS5Jden/qtdbG6Tq+qG2w8QsFIxbBgoiAC+aPBGdByLg28v3xXNHxPLFQLouqkeUlRYMtKS6tvmJ/tXbcwuf1D/zxQi9CZ+chX6hUgpqZZZWMhoKsuNQ8a37z1qSBD1Nv4Ke79/Hwzo/YuXMfu5tt/PLdNh7d3cLPm2082mzj1+/b+O1eG7/f28IfPzzA159+hlLORk03UVU1FGXlJpVPJZXFs8p6deLS2nkiZ47IiRM5Mh1zLDrlZOmcY9MZp0CnnQqddOo06SzRhLNCR53GkXOOeXHeKcwnnFIi8a45Nxf7GwiUjd5m0JylAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-2-select-language",
            "title": "vm-install-2-select-language",
            "src": "/static/c2e37dbce239c1c7cc955665ff68de0d/fcda8/vm-install-2-select-language.png",
            "srcSet": ["/static/c2e37dbce239c1c7cc955665ff68de0d/12f09/vm-install-2-select-language.png 148w", "/static/c2e37dbce239c1c7cc955665ff68de0d/e4a3f/vm-install-2-select-language.png 295w", "/static/c2e37dbce239c1c7cc955665ff68de0d/fcda8/vm-install-2-select-language.png 590w", "/static/c2e37dbce239c1c7cc955665ff68de0d/efc66/vm-install-2-select-language.png 885w", "/static/c2e37dbce239c1c7cc955665ff68de0d/c83ae/vm-install-2-select-language.png 1180w", "/static/c2e37dbce239c1c7cc955665ff68de0d/0c1ff/vm-install-2-select-language.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Install Ubuntu`}</strong>{` and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ace0b5b9380950316a7d25aba01afd41/0c1ff/vm-install-3-install-ubuntu.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADXUlEQVQ4y5WRbWhbZRTHn4p929qtrm1emi1JkyYxN0nTNKNrmnRvriSt0l5qb207uuEHX0AUih9kKGOgBllBURB16+o+iNskq3cMipSKDIYflIIDnXGWZetedGOKXZKbe+9z7/OX3Lj5wU8e+MF5OOf8z+H5k3AkPMmFuCWHy7FgsZjFMuaHmERrm1V0e9yiy+0SLVazaLKYxId9ZpNoabOI7R7Xl25fx+K2dvsOwjU53/PV2+DfYMc+fwxJLo6hQD+eCu4C37kHo+G9ECIDGI8MYKI7icloEqlQHIPhBCZ6UkZ9oC1ikDAH9pPgI1vf8pNWPO3ZIzNVp1pJpbSoUE1SKJOpgXy/SJX7EoWiGeiySlVJpgDorWyOvugZVKZb45iwxcZIV7UzHSQWjHMD5QbGwPAg/s3+G4xVqmu5a2xoa7c+3hLF1LaYQLbXuNLdxIapQJI+0LjxSw5XL/9qDOg6Q0nVoNAKJUWFrFJo/2y7vnqVdW9x6tFqM5LNXoH01XnTvcSB6UDKEFw8voDp5hhGmkI4+f68MVS4cgn3spewvvoTCrmfUcxlod5YBWgJN3NrbK/pcT1Q1YRgfYtAdtb70wniwnORYUoZ2GxiGKK3FV8FW/BGdBdK+QJwZQV//vAt8j9+h1J2BVJ2BfLl7wHpL9y6dpONtoX1nTUW9DZYBZJq7Ervq/Lh+a5h48LTr76Jw5tteKfZhnMvHzIuLBbyuHP7NvLr65CKBeNdzOeN2m+5Nfass0cfbXRgaItDIM8096XHaqN4ZbtgCJYkBYtz57B07CxKhZIxpKoqJEmCLMtQVBWyohh5OX7PrbEZb5/+QosXB6wegUy1JtIHG+I43HeQsrJ1FftYxUjGNKoxpjMGnTGm64xpFfTyBwHsbu46O8L166/bOMw4OYE8+Vjk7ZHaThyKTytlU/8vf9y5q70b2U2PtgdxxBsUSHJTaHawLogD7idw/pNTOP/x51g8fgZLcxl8fWIByyfOYvnYF1iey+Cb+QwufJrBxZMZXJw/jQtzn2F59gN82BnDR74Qjvq5CdKz0eXr3+Qb661pH7ERwttJFe8ghPeSar6TbOTDpJHvIpv5KGngd5ANfJzU8btJDZ8ij/I8qeYnSS0/Y+/gX+voGH3Jabf8DZ+7kOb7tzOoAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-3-install-ubuntu",
            "title": "vm-install-3-install-ubuntu",
            "src": "/static/ace0b5b9380950316a7d25aba01afd41/fcda8/vm-install-3-install-ubuntu.png",
            "srcSet": ["/static/ace0b5b9380950316a7d25aba01afd41/12f09/vm-install-3-install-ubuntu.png 148w", "/static/ace0b5b9380950316a7d25aba01afd41/e4a3f/vm-install-3-install-ubuntu.png 295w", "/static/ace0b5b9380950316a7d25aba01afd41/fcda8/vm-install-3-install-ubuntu.png 590w", "/static/ace0b5b9380950316a7d25aba01afd41/efc66/vm-install-3-install-ubuntu.png 885w", "/static/ace0b5b9380950316a7d25aba01afd41/c83ae/vm-install-3-install-ubuntu.png 1180w", "/static/ace0b5b9380950316a7d25aba01afd41/0c1ff/vm-install-3-install-ubuntu.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Interactive installation`}</strong>{` and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/89585e90fe09afc91a59908fc6414bd2/0c1ff/vm-install-4-interactive-installation.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADSklEQVQ4y5WRXUwUVxTHL035UiBWgZ1ldXfZT3fYZVm2RWDBqpUs0DZMKENBo6TpgyY+GJ6axjTxod0HTdqkSdM2qO1DU/uBOomJD6IxJppo2obSlqY21EUKlaIgCrs7M/fj3+zQ8lxv8su9J/9z/vecHBKNRQfliHzZ5XGdlySblse2TrVmr7FrPr9X83g9mmS3adVStbaeZ6vWpBpJq/V7LniDvkvbap07iLzJ/UGw1IHQBif2hlqQlBPormvHK+EXodTvRm90D9RYB/pjHRhoTGIwnkRnpA1d0TYMNHVaekdNzKLNVrefhJ/Z+m6IVOE1/25dmJyynEl5jlKuUyp0RoVOqf4kQ42VLIXBLPKamdUpADr3W5oe9ncZB6oSGHC09JGGQncqTCT0yx35BIH/eYRYS51JT4vurY28vzKOfdtaVPJ8kSfVSBzYX5e0DDnnEFz8V4V8nDMZdJPCoAw5w7Te/F/je1N3ReNmN48X2pDcElBJa0kg1UxcGIp0r3fIGEN2eckqEoaOzORtPJi4hYUfb+HRL98h8/sEjKmfAH0Fs9N/ij1V23ldwSaESytVsrM0lGonXrwZfdUypNlVPFpawsPxm8jNz6x1OTWBJ79+j8ydcdA/fga7OwnjzjiQfYy56VnRWxPlO4skNJfZVdJZ3pDaW7Adh2I9lmFWN/Bg8gcsj50FXX5ojbWa0zE3P4/Zv+5jYXERj1dWsZLJWtr99Ix4w93Ee8td6N7sUsnrW1pTfcVxHH1BXRtZCDDTWN+OEByMUhiGvoauwzQMUNO09Pn0jBgOtPJDlQEctPtVsq+qLTVUlsA7rUNUAIIxJjjjglMqGKWC52POheBCCOvmQjBuafn/FtL3xHG5nR9zyBh2yyp5+bnYez3F9Xg7ccAArD08FYt/L7D3Y7voidowjgfCKklWRE52lYRx0PsSLn56Fhc/+RKXRr7G5VOjuHr6PMZOn8PYyDe4MvItrp05h+ufjeLG56O4ceYrXD/1Ba6c/BAf1bfg42AEJ0LyAGna6Am2VwT7motqexyEKE5SoLgIUQKkUKknZUqUlCkNpEKJk3JlB9mgJEiJsosUKZ3kWUUhhcogKVaGnT7lLZ+v94jbKf0DkyKnRRxr00MAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-4-interactive-installation",
            "title": "vm-install-4-interactive-installation",
            "src": "/static/89585e90fe09afc91a59908fc6414bd2/fcda8/vm-install-4-interactive-installation.png",
            "srcSet": ["/static/89585e90fe09afc91a59908fc6414bd2/12f09/vm-install-4-interactive-installation.png 148w", "/static/89585e90fe09afc91a59908fc6414bd2/e4a3f/vm-install-4-interactive-installation.png 295w", "/static/89585e90fe09afc91a59908fc6414bd2/fcda8/vm-install-4-interactive-installation.png 590w", "/static/89585e90fe09afc91a59908fc6414bd2/efc66/vm-install-4-interactive-installation.png 885w", "/static/89585e90fe09afc91a59908fc6414bd2/c83ae/vm-install-4-interactive-installation.png 1180w", "/static/89585e90fe09afc91a59908fc6414bd2/0c1ff/vm-install-4-interactive-installation.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Check all of the available boxes to install proprietary software and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ff9ffa305c66f8391bbbaaffe474236b/0c1ff/vm-install-5-proprietary-software.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADHUlEQVQ4y5WR3W/TVRjHnxn3BmxB2NZuhbbrq/2tL+uqY1s3hMlYNzU7zP3mBoHFeIGJF2ZXxhgTLrQXkGhiYtQM0AvjCw5sQsIFYAwJf4CXS3ypXRRha2FA21/b8zvna36HUC+84px885xzvs/55HnOoVg8tqhFtKsuj+uS3W7LWLLV1ZXp6enO+PzejNfnydi7bZkuW1emnmete+yZXr/nR2/Qd2Vvr3MfaTvdHwdbHQhtc+JQaBiTWhLTfWN4OfwCWPQgjkTHMRefwHz8MBYGDmMxkUIqksRUbBQLgynMxsYx0RNXGrX1HaPwU3s+CFEnXvUfrMia4KZR48LgXFQ4l1WTC6PGjftFXn1Q5rLCOayzSo3XyhUOgP+9luVv+qeqxzuTWHAMz1F/ozsdJjvmtQkrQeIJx3r2Tzm9Z0DMdyRwdO+wTs81edID5MCxvkkFFEJAyv+41r5cLsMoGyo+llEuKz/3W1YO7HKLRKMNk7sDOo20BNJD5MJSZLpeoWl1tnELolqBaQoUCgXk83lsbm7WYyGfV8C//sjJ8a6Q6GvYiXBrh077W0PpMfLijdgrCmg8vI/C72u4t/YLSpu3H1VZ3EKpVEK1Wq3LMAzl3crm5BFHv9jfZMfQjm6dUm396UMNz+JkfEYBH97N417uV5hW60KoS/zuHVVlsVhUYAWvVJX3T3Zdvu4eFLNtLkzvcun02u6R9FxzAm8/r//vUx5vzNIDbG1tKaD1fo+AFeXdzq7L5cCIONkRwIluv05HO0fTSzuSeH9kiUtAmtyUJucqCkumKYWEmlKIugS30iE3sjl5ShsT7zk0LLs1nV56Jv7hTHMU7yaPWz2IJ1Xhzob5UfwAP90bxqlAWKfJ9siZqZYwTnhfxOUvvsXlz7/BlZXvcfXsKn46dwnXzl3EtZUfcH3lAn4+fxE3vlzFza9WcfP8d7hx9mtcP/MJPo0O47NgBKdD2gINbvcEx9qDc0NNvTMOIuakBuYiYgFqZFHazmLUxuLUxhLUzvbRNpakFnaAmliKnmaMGtkiNbNlp4+94/PNvuV22v8FQHuql3j1bMIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-5-proprietary-software",
            "title": "vm-install-5-proprietary-software",
            "src": "/static/ff9ffa305c66f8391bbbaaffe474236b/fcda8/vm-install-5-proprietary-software.png",
            "srcSet": ["/static/ff9ffa305c66f8391bbbaaffe474236b/12f09/vm-install-5-proprietary-software.png 148w", "/static/ff9ffa305c66f8391bbbaaffe474236b/e4a3f/vm-install-5-proprietary-software.png 295w", "/static/ff9ffa305c66f8391bbbaaffe474236b/fcda8/vm-install-5-proprietary-software.png 590w", "/static/ff9ffa305c66f8391bbbaaffe474236b/efc66/vm-install-5-proprietary-software.png 885w", "/static/ff9ffa305c66f8391bbbaaffe474236b/c83ae/vm-install-5-proprietary-software.png 1180w", "/static/ff9ffa305c66f8391bbbaaffe474236b/0c1ff/vm-install-5-proprietary-software.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`This one may sound a little scary, but select `}<strong parentName="li">{`Erase disk and install Ubuntu`}</strong>{` and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{` (No, this won't erase your host OS and all of your favorite cat photos).`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6efeaad106340de6ff1790303f493655/0c1ff/vm-install-6-erase-and-install.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADJ0lEQVQ4y5WRXWgUVxTHT0rzpSZYTXYnWd3v7HYnu9nsbhuTbGL93iRFMmwzaaJoEB8s9KHkqZRS8KHdB4UWCqUtUduHUvsR7YDgg1FE0MdCXwp9KK4bFD+q64Y0uzNz596/zGyIr+2FH/ce/uf+z7nnUjKVnJUT8jVf0HdZktyajXsDl9bVLWmhcFALhgKa1OXWXJJL28hzuzSpW9ICPcHfQtHw1Z0B7y6St/q/iLZ6ENvkxYHYEHJyFhO9ozgcfwtK317kk/sxnT6EmUwOs+kcZjM5jCVGMJ4cwczAGPLJfTjYnXIYcfcepfgrOz6NUSfe6dmrC5Mzq2YyXmOM64wJnTEYFjNWa4yt6QwGd2JbM6s6A8Ae/FVk7/WMG8c6s5jxDE1Rf6O/ECcJ0/JBO0HgPy6xnrpcvCcmdqT5dEcGR3YOqfRGU7CQJg+O9uYcQ845BF/3FQJ2rBsmDN2AYRjQdd3ZucWdlNLfRZHe5ueZRjdy2yMqDbdECoPkw1xiYqNDy7JQrZTBhYAQ3DlXKhWsrKygXC6jWq1CiHrR+3dLYp8rxnsbtiLe2qHS7tZYYZRCOJk87Biy6r94Xi7j6R93UHtYqjdaW8PaWp1arQbTNDde8eBuSeQ9/Xx3k4TBLV0qjbX1Fw40vI5TqUnHsKob+OfP31FZugiz8tS5ZHGO1dVVB9vMMTVMR3tYXBYn/AM83+bDxDafSu9uHy5MNWfwwZtq/clCwDKNl79jz9GynNnZMMbqmHXDR8VlMR8Z5qc6Ijje1aPSkc6RwtyWLD4ZnmMCEJZlCW5xwRkTFmOCr8f1cQohbG1dt8s9KZbEaXmUf+yRMe+XVXr7tdRnk819+Ch7zADA/y/PHj+xPk/tYWcCcZyOxFXKtSfOjrfEcTy0H1e+vYgr3/yIqws/49q5Rdw4fxlL5y9haeFXXF/4BTcvXMKt7xZx+/tF3L7wE26d+wHXz36Jr/qG8HU0gTMxeYYGNgejo+3RqcGmwKSHSPFSg+IjUiLUqPTRZiVJbUqK2pQMtSu7aJOSpRZlDzUpY/SqolCjMkvNyrw3rHwYDuff93ulF3I6q3eIPcd5AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-6-erase-and-install",
            "title": "vm-install-6-erase-and-install",
            "src": "/static/6efeaad106340de6ff1790303f493655/fcda8/vm-install-6-erase-and-install.png",
            "srcSet": ["/static/6efeaad106340de6ff1790303f493655/12f09/vm-install-6-erase-and-install.png 148w", "/static/6efeaad106340de6ff1790303f493655/e4a3f/vm-install-6-erase-and-install.png 295w", "/static/6efeaad106340de6ff1790303f493655/fcda8/vm-install-6-erase-and-install.png 590w", "/static/6efeaad106340de6ff1790303f493655/efc66/vm-install-6-erase-and-install.png 885w", "/static/6efeaad106340de6ff1790303f493655/c83ae/vm-install-6-erase-and-install.png 1180w", "/static/6efeaad106340de6ff1790303f493655/0c1ff/vm-install-6-erase-and-install.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Enter your preferred name, username, computer name, and password. Note that this user will have root/sudo privilege on your VM. When ready, click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/330a9c6a0a9b10e78ed837f3394a4965/0c1ff/vm-install-7-username-and-password.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADOUlEQVQ4y5WRS2hcVRjHT8S82ia0Nsm86sxkns6dmUxuRtMkk9Q2Np0kUnIac9ukpQ3FRQUXkpWICF3oLFpQEMRXW12IGkjrQKGL2CKFrgSXgi7stANtJ334YObeufeee85fzg0VRTd+8MF3zv/j973IoJpbSmeV9XAkdMnn9ZS9f3OPt6/s9/vKsXi0HI1Gyj7f5p/UZK7H01f2+b3lSDzyTSwZuxLsD+4myvbwe8nOAJQtQexPjaKoFDCbnsDBzPOgA/twKDcJTZ3CEfUAFoeKWMoXMZ0tYCY3jsXhacznJjHlV3HAr2Lckz5GMk/sejtFevFSfJ8pbM6cps14kzFuMiZMhwmTMaveZEw3GWzOYDmuZhsmA8Du/FRhr8RnrOO9BSwGRhfIYGu4lCFeHFamZILAfxhzHDCHgXHnX1q1ckvM7hrih3vyOPr0qEaebYuUhkgAx9JFFyg4d6mPyYwxbNQ2ULtXQ71eh2VZsEwLuqHDBkP1l4oY2hHm+VYPijsTGhnrSJRGSAjL2dlNoBCwDAON79chfq2BA2jU67BtG47jgMuCQsC0TOjCwJ2bVTHZl+Lplu3IdPZoZE9nqjRBong5d9AFskc1NK6t4sGPP6D5x29up7recDuV1mw2oes6LMuEA467lao4FBjke9q8GNnm08h012Bpf8szOKXOuUC7/jse3vwZTYe7u5PdyFElRMaGYUBvNGCam8BapSpOhof5fFcIs0+FNHJk51hpoT2P157TXKAciYt/3sZ+eM/tUsLkDqW5eQA2KlWxkhjjp3oSOOGLa+Ro73hpeVsBb40tMyGBDhcOc/5y+WY2E4ZhCEM3hMOY4FKzmXu7+5Xb4rQywd8MKFgJKxp5cYf6zlz7AN4oHJel+f/1Rxv3nXfVvexMfwanExmNFLuzZ2c6MjgRfQGXP/4Klz/6Elc+XcX6uTVcO38JV89fxLcy/mQV311Yw/XP1nDj8zXcuPA1rp/7AlfPvo8PBkbxYTKLMyllkQxvjSQnupMLI239cwFCaJC00BAhNEFa6QDZSnOki6qki+ZJN91NttAC6aB7SRudJk9SSlrpEmmnK8EYfT0Wm381HPT+CVEQqplEfO90AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-7-username-and-password",
            "title": "vm-install-7-username-and-password",
            "src": "/static/330a9c6a0a9b10e78ed837f3394a4965/fcda8/vm-install-7-username-and-password.png",
            "srcSet": ["/static/330a9c6a0a9b10e78ed837f3394a4965/12f09/vm-install-7-username-and-password.png 148w", "/static/330a9c6a0a9b10e78ed837f3394a4965/e4a3f/vm-install-7-username-and-password.png 295w", "/static/330a9c6a0a9b10e78ed837f3394a4965/fcda8/vm-install-7-username-and-password.png 590w", "/static/330a9c6a0a9b10e78ed837f3394a4965/efc66/vm-install-7-username-and-password.png 885w", "/static/330a9c6a0a9b10e78ed837f3394a4965/c83ae/vm-install-7-username-and-password.png 1180w", "/static/330a9c6a0a9b10e78ed837f3394a4965/0c1ff/vm-install-7-username-and-password.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Select your preferred timezone (dream destination or actual timezone) and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Next`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/82cc879f986def6d0762e16a74dfba81/0c1ff/vm-install-8-timezone.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAD2ElEQVQ4yz2Ra0zbZRjF32yDMYaIONZykZVS6KBAYYCsAm5yGeCC/kEqEFyM8csSo9H4wcSYLDHaGEk0Josu7AIDFZCLJS4LTJBuTMpgwspgE5Bbh6Wl9kJL15a373uM1fjhl5znnDxP8uSQ7BxloyIz/YZEeqRfLBZpxeLD/yMSHdbGxYm1MlmyNjk5SSuOFQW9f7JY8b86NlaslaZIf5TJZdcTkxILSHqU5Ev5gXikhT+DsvRCVCqK8WLG83gp6wUIyhLUKktRl1OO+mMVaMytDFKZVYQqZTEanq1CrbIE5XE5OBWXgyKRoolk7En45CiJQV1qiS/g9VK/y0V3d9zU59qh1OOj1OOluy439TqcNLDjofD5Kff5aODxYwqAbv6+TM+mVPnPxBSiIV5VR7JDJJpMIkaNvJTOGR3csLSN6SU71sx2mGxuGLe2sWhyY3b1L9z7w4L763bMrzswu2rHQ5MHo+NzvDL+GKs/lIfGBJWa5IZINfkkAdXSUjpkcPHPhgfwle46xh86YHE+Di5eGv4TvXoLtJMW6OZsuL/uws/3tjAyv42Wvrs844lElh8qQnl0qpqo9qdqniMSqOWnqGHVz/uWLmPQ2IkFox/DBgs6x0wYmtmC3e3FjtcPzgIAOCjdxYLZi++vzfDCp+Qsc08U0sOeVpOisKOak0QGdWolbb/l5H0TBsyZdZhd8+HyyCN0/7qJFfMOjFYPnG5v8BBjDHcWbOi4bcX5rileLcpiJ/bHouCgWE0qIpSair1paJSfpt16K28ZXkfL8ArGHtgwMLkVfNPm8oEGAphYdGBkdguTizZ8e3MDnXorLvb8xl9LyGOvREpQFZ2oJupolab+QB7eUNTQbr2Zt+tM+Lh3NViEy7OLqzoTBqa24Njxo3/CjNZfTOjVbwaLGZx1oOWHu/xtqYqdjUnFmdgUNWk4VKh588kivJPdRNt0Jn5hcJ2f61riN6Yt/NqkmbcMGXn76AbvGTfzK8OP+JWRjeA8MmPhP03b+YXOKf6hvJB9lKDAu0fS1OR0VM6nNWFKvF/Q5Dd6wJbsnM1ZOdvwgC1vg626wJadYEu2AFtxcrbqBltxgT2wMjZvY2zSsBZoVp6gzUkZOJeSoSYVkZnNVWEZeF1WhsFLXRi82IWR1h6MtvZh7KoWN9v6oWvrx63WXtxu68V4Rz/udPRhsr0b+rbvoPviPL7OUuEbeSY+T0tvIPkHpfLiSHnd8ZCkl0WECHH/kUz2CekkXFCQCCGTRAhKEiHkknDhOAkVikmIUEb2CtVkn/AqCRXeS5QJH8hktW9JEsV/A5rUfTh1o8H9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-8-timezone",
            "title": "vm-install-8-timezone",
            "src": "/static/82cc879f986def6d0762e16a74dfba81/fcda8/vm-install-8-timezone.png",
            "srcSet": ["/static/82cc879f986def6d0762e16a74dfba81/12f09/vm-install-8-timezone.png 148w", "/static/82cc879f986def6d0762e16a74dfba81/e4a3f/vm-install-8-timezone.png 295w", "/static/82cc879f986def6d0762e16a74dfba81/fcda8/vm-install-8-timezone.png 590w", "/static/82cc879f986def6d0762e16a74dfba81/efc66/vm-install-8-timezone.png 885w", "/static/82cc879f986def6d0762e16a74dfba81/c83ae/vm-install-8-timezone.png 1180w", "/static/82cc879f986def6d0762e16a74dfba81/0c1ff/vm-install-8-timezone.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Review your choices and click `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Install`}</code>{`. Wait until the installation is finished. After the installation is complete, click the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Restart now`}</code>{` button.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/0c1ff/vm-install-9-review-choices.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADOElEQVQ4y42R7W9TVRzHz4SNjVFE2Nq7la1du7b0aV1bnHvoRniY3aZm17oLG2QshhcjMdHgKxZC4AU2AV9ofCEqLMY3EAXhJkt4gRA1JsY/wERemBQmTyvrMq/teu8995yvuUfZa07ON+fh+/t98jvnRxLJxFQkHrnt8XluSJJLteVal1NtaZXUzoBf9fl9qtTiUp2SU12PczlVqVVSOwK+m/5Q5622jvbXSGSb95NQgxvhze04EO5DNjKAsegg3oztgdy1F7nEfijJYRxKvY6pVBZT6SxG4hmMJjKY7BlBLrEPw61JoYwreoTEXtp5Lkya8U5gr85NRq2qSVmVUqZTym0ZFtW1NWqWqxQGozAs4ZlrOgVAH90r0OOBUWO6eQCT7r4J0l3rzceIhIORYTuA4wXH88DFwn0+tjPFDjalcbitTyG763z5FHHjSDQrgJxzcC42IsGiFlZXV6H9raFSqYAxJjxmMeE/+LPAU9u9LF3rQnZHUCH99cF8L/FgJj4mgJRS6GUNhl5dhxaLRWiaBtuzoaVSCUtLS8J7VFjk+5xhFq3ZhlhDk0KGGsL5QeLHscRbArhWqaBcfILl4hLK5bJIWl5eFhDTNGEYhrhfKZWE97iwyN92d7OhOgm9W1oUMuLozh+o2YXZ5LgAmoYO7dlTPLz3O4qPH4okG7aysiJg4gW6Liq2x9P7f/F3vT0s5/BgbLtHIYd29OcnNqXxwavKelNYRYNR1mCx//7JhtlV2utzuF2lHfyk8ICfCPaz2aYgjrYEFHK4OZOf2TKA0/0z1O4Foxa3LMa5PS3GmWVx0zC4XtX/V1WcQZnN4/8sFvmZSIadckdxwhtRyBuvJD8a39SFuYFpwy7uRVWGzu6u/sp++eNn67P0MD3vjeJsMKaQ7Nb4x6P1MRz178fCl1ex8MUV3Lr0LW5fvo678zdwZ/57/HD5Ou5c+g4/zl/DT19fw2/f3MTCxYuYOzONT+dm8VX3ED4PxXAhHJkkPY2+0ODW0ERvXce4mxC5ndTIHkLkIKmVu0ijnCAOOUkccpo45B7SKGdIvTxENsg58rI8tyEuf7jRI7/f1iGf7Azk3vO2S/8Cz7KoW7vryYYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-9-review-choices",
            "title": "vm-install-9-review-choices",
            "src": "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/fcda8/vm-install-9-review-choices.png",
            "srcSet": ["/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/12f09/vm-install-9-review-choices.png 148w", "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/e4a3f/vm-install-9-review-choices.png 295w", "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/fcda8/vm-install-9-review-choices.png 590w", "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/efc66/vm-install-9-review-choices.png 885w", "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/c83ae/vm-install-9-review-choices.png 1180w", "/static/1e9bbf4e6d1bb1a19a3ce5391eb3a679/0c1ff/vm-install-9-review-choices.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/0c1ff/vm-install-10-installation-progress.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADIklEQVQ4y5WQXWhURxTHj0ISU1exmmR3s3az2c/uV/YjbZpkEyVquklEcom5JipGiqCCD5oXSykFC+0+WFqhkNoNLajURsG2CxZpi7YKrWCf+1BKNUZa0mzWJRu02Xvnzvzlzm7Ft+LAf/7DOWd+c85QPBHbG46GfnC5W76226w52zOy2ppyzc32nNfnyXm87pzdXomZObPWam2SMbfP/Y034L3mbHW+RqENrjOBegdCLzixI9iFdCiFoXAvdkW2Qmnrw0hsG9REP8aSr2M8mcbe9jQGoj0YjPVgvGMAu+Pb0e9Ior85gR5reD9FVm9+L0iN2O3rKwudM2NFZ3yFMV5mTJQNJsqMlZcfM/3RCoPGGTRD5vR/ywwAm/9jjh31DWoHGlMYd3SNUrzGlYmQDXtC/WaBwP8uUd0rPjd7XwxtTvI9De3Y91KXSq/UujNJcmB/OC2BQghzk/fkmYuq84pXkQZjFeCfsyK50cXba6xIb/Kr1L3Gn+mkFkxEhySwWCxiYWEBi4uLT7W8vPy0N/HbLxClAni137/uzYltTUEeXrUBkfoGlbbUBzO95MGh2C4JXFpawmI+j3w+DxNuML0CevA7+MfHwKdOgH90GPz78xL4991ZMeKI8y21NnRa7CoNrItndqx6GUcSwxJYKpVQKBQkTPrDh9BNYnEefPokxIV3waeOg9+5JoHzd++LN1wdfGRdC4Y2tqg0tqk7M1rXjuOvqhKo6zq0sgbpmibFqv8lO+WVYf8b+Z/ZB2LS382PNPgxYfeptK+xJ3PQksI73QeZ+f3c4EJwURWXMmOcGRWZZ8MQhib7Fgv35sSpcC9/2xHCpCuk0s4XE+8P17XhrdQBrfrwc6lUKBofxrey060RnPJHVEqvj34wuCaCCc92XJ2+hG+zM7h69kt8l72MG59/heufXZH+Y3YGP316EbeyF/Hz9Be4nT2HX89fws0zn2Aq2omzgShOB0Pj1LHWHehdHxjtrG0dbiZSnERKK61WAlSntJFFiZFFiZNFSZJF6aC1SorqlT6qU9JUo+wkUsaoRpl0epU3Pd6RYy6n7Qk26KTXLF+5VAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-10-installation-progress",
            "title": "vm-install-10-installation-progress",
            "src": "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/fcda8/vm-install-10-installation-progress.png",
            "srcSet": ["/static/6e7cabaf7fa8c1e90ac57f0cb005c763/12f09/vm-install-10-installation-progress.png 148w", "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/e4a3f/vm-install-10-installation-progress.png 295w", "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/fcda8/vm-install-10-installation-progress.png 590w", "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/efc66/vm-install-10-installation-progress.png 885w", "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/c83ae/vm-install-10-installation-progress.png 1180w", "/static/6e7cabaf7fa8c1e90ac57f0cb005c763/0c1ff/vm-install-10-installation-progress.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/575896b3e55d38824b5d571d3ae4c90f/0c1ff/vm-install-11-restart-now.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADP0lEQVQ4y22Rf2jUZRzHP5o7XZtiuu1+6d3tfnY/d7fV3O42ZWvrton4tPZd06UjCAwMYv8UEYR/1AWG1T8hrbJBCM3VvD9MSLEahaBhzUAQsp0biqzS2q15P57v87zj+72jtfCBNw+fz/vzvHg/z0PRWMO+YDhwzuG0T5lNxrTpPzKa6tIWiznt9rjSLpczbTaXepqnzRqNdWmzxZR2epyn3T73WVu9bQcFNjve9VVaEXjYhi5/K5KBBPqC7dgT2gUW6cBTkU4MRLswGOvGUGMS+5qS6Akn0NvQhqHmHvQ3dKLbEsOTlhjajMFhCq3d9oafavG0pyMvi4KruSIXOc5FnnOZV7nIFXl+8W9eyN7nKKgcBaF7xft5DoDfvp7hL3h6CwdqExiytg5QtMKRCpEJg4FubUBi1fpf+QBnPnNT9m1rFIM1Tdi/vVWhxwzOVCNZMRxM6kApBKSU0PfyQXHtIsSNmX9rzVNVVQfO3cjIxi0O0VRhRHKrV6H4Bm+qhewYCfeVgGWYnmLmG8gzH0CMvQw5eQxy8h3IW7/onigDb83Oyc46vwiu2YxQZY1COyv9qXZy4fnonhVgeVhOn4J4cQdEahjirWchDjdD/jpTAnKu77dn52S/NSp2GkxoqTYr1LMxmupa8ygOxdgKUJM2zYuQV7+F/Hka6pXz4NcvrTxD+RZ3MvPyOUez6N9oR98Wu0LPbI2nBtY34aXHlVXA5eVl/LW4iGyBI5vnEFpoASxll5DL5yBF6VsWMvNy1BsXh2q8OGj2KLS/ti01Up3A6/ERrqFUruoSqpD5XE7e+/0PufDbHXnqpwk5/sO4vLt0V4svebGoh12YvSmPBNvFa9YARh0BhXY/Entz7/oIXk0cKJQyPFhXl6+JS4s/arlW9bP3/lSPRXfxo/UhHPGGFEpuCr/duyGEg64ncObDCXw59hnOjk3g3Eef48LHU7hwYgpfnziNy59+hSsnz+P78Sl898kkLo5P4PLJLzD93nG8H27BcV8YR/2BIWqucvraN/kGWg31ey1EbDsRsxMxL1WwCFWxCFWzBqpiQVrHIrSWxcnAOsjAkvQQ203EBmkdG7W52Ssud/9hh830D/BWoIcKBQOUAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-11-restart-now",
            "title": "vm-install-11-restart-now",
            "src": "/static/575896b3e55d38824b5d571d3ae4c90f/fcda8/vm-install-11-restart-now.png",
            "srcSet": ["/static/575896b3e55d38824b5d571d3ae4c90f/12f09/vm-install-11-restart-now.png 148w", "/static/575896b3e55d38824b5d571d3ae4c90f/e4a3f/vm-install-11-restart-now.png 295w", "/static/575896b3e55d38824b5d571d3ae4c90f/fcda8/vm-install-11-restart-now.png 590w", "/static/575896b3e55d38824b5d571d3ae4c90f/efc66/vm-install-11-restart-now.png 885w", "/static/575896b3e55d38824b5d571d3ae4c90f/c83ae/vm-install-11-restart-now.png 1180w", "/static/575896b3e55d38824b5d571d3ae4c90f/0c1ff/vm-install-11-restart-now.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`When you see a screen with a black background saying `}<strong parentName="li">{`Please remove the installation medium, then press ENTER:`}</strong>{`, simply hit the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ENTER`}</code>{` key.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8c26d212fe036de20a59cf572b1683a3/0c1ff/vm-install-12-remove-installation-medium.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAABRElEQVQ4y62SzUrDQBDHZ2Yb8tXQoI3U0mw+alppxYsHTz6DUSwofR314kF8Ec3Jg09m0e5IwlJqiZVqDz/Ynf/uj9lh4SBNb/pp8hbL8DmWslgmkmGRJnExzLJiOMiKJI6q2uq5WMqXWMpXGfZOQRA9IiJvAyHEFBDxFgAYAN4B4OM3sL4+Kx1EdFUK77WwDJReb0J5Z66Fk3qh43HUsVh4HoO/y+A0GUyX/aDFoz3gtgvcoE2ErR1ujzKm/R5DPGCUfYbDE+6OU54eA18cAfvWJsKtP3kN+F9hKTBNkw3D+HOHFUSkbMdRYFiq6XnKdV1l2baybVstn6sT3mnhTAcLbIL5pNuYOw2q9ojfc82nbmYhfPhpXr6B/HQmeZyE3JMRB0Gwdr5EdA1CiGH5w4nonIjyZZAoB4AcEPPVrIZLIUTnC7+c8U05E1qKAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-install-12-remove-installation-medium",
            "title": "vm-install-12-remove-installation-medium",
            "src": "/static/8c26d212fe036de20a59cf572b1683a3/fcda8/vm-install-12-remove-installation-medium.png",
            "srcSet": ["/static/8c26d212fe036de20a59cf572b1683a3/12f09/vm-install-12-remove-installation-medium.png 148w", "/static/8c26d212fe036de20a59cf572b1683a3/e4a3f/vm-install-12-remove-installation-medium.png 295w", "/static/8c26d212fe036de20a59cf572b1683a3/fcda8/vm-install-12-remove-installation-medium.png 590w", "/static/8c26d212fe036de20a59cf572b1683a3/efc66/vm-install-12-remove-installation-medium.png 885w", "/static/8c26d212fe036de20a59cf572b1683a3/c83ae/vm-install-12-remove-installation-medium.png 1180w", "/static/8c26d212fe036de20a59cf572b1683a3/0c1ff/vm-install-12-remove-installation-medium.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`To log in, enter the password you chose earlier and press `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ENTER`}</code>{`
.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8ee4c468e10bb5c2f160ab6948465a3a/0c1ff/vm-login.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAABsUlEQVQ4y52TzW7UMBDH9wkQEtuluy6xPZvYjpO2m6zUj4hDpWrPWKhIIKTyMoULB3gSyIkDT0ZV7EF2nZUDVNAe/hprZvybmYwzqSr9ptLldynFFylFP0h5K0SvS9Wv26Zvm1VfKhl8KsnzqnT5ta70N1HkxxPG2CcAQM75nRJCYFEUd8bzPA9xxthbD7ziAQg/OMDNSJzfQLSj8zYOg+/agymlFx74IXboAy6tPHROKfXVR75EDgCs91NKX/0B9OdBA2Cz2WDXdQGaxmNOAMbCfwemnfhv8+7yEo0xW/+9gNtLnGNGKeZFge16jU3bIuN822VS9N8dQkheYltr7NpD7NarYE9W+1hLEcAPGvlAl7jSCmslAuhQKyxFMRr9f0Z2HMAB5y6jzO3sUfcsoy6jt2K3ADfkxvNoy+9jteu4fgvALeVgD3JmPz/P7NF+aZWurJLSxsupfsa3iFmWBeDH318+AEfKAeuc4dV5hWenR3h8copt04yWkr4G/zdJKV9PFouFJIRcEEJeEELMoD1CzNMFMZNHu+bxk6nZmU7NbDYzac6g+XxulsvlSynl7i8pL0yPrxSdOQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-login",
            "title": "vm-login",
            "src": "/static/8ee4c468e10bb5c2f160ab6948465a3a/fcda8/vm-login.png",
            "srcSet": ["/static/8ee4c468e10bb5c2f160ab6948465a3a/12f09/vm-login.png 148w", "/static/8ee4c468e10bb5c2f160ab6948465a3a/e4a3f/vm-login.png 295w", "/static/8ee4c468e10bb5c2f160ab6948465a3a/fcda8/vm-login.png 590w", "/static/8ee4c468e10bb5c2f160ab6948465a3a/efc66/vm-login.png 885w", "/static/8ee4c468e10bb5c2f160ab6948465a3a/c83ae/vm-login.png 1180w", "/static/8ee4c468e10bb5c2f160ab6948465a3a/0c1ff/vm-login.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Your Ubuntu Desktop installation is ready. Congratulations! `}</p>
    <h2 {...{
      "id": "part-5-installing-guest-additions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#part-5-installing-guest-additions",
        "aria-label": "part 5 installing guest additions permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Part 5: Installing Guest Additions`}</h2>
    <p><em parentName="p">{`This step is optional but highly recommended.`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://www.virtualbox.org/manual/ch04.html#guestadd-intro",
        "target": "_self",
        "rel": "nofollow"
      }}>{`Guest Additions extend the capabilities of VirtualBox in several useful ways`}</a>{`, including ...`}</p>
    <ul>
      <li parentName="ul">{`enabling bidirectional host `}{`↔`}{` guest copy / paste support`}</li>
      <li parentName="ul">{`sharing folders across host and guest systems`}</li>
      <li parentName="ul">{`dragging and dropping files between host and guest`}</li>
      <li parentName="ul">{`graphics improvements`}
        <ul parentName="li">
          <li parentName="ul">{`higher resolutions`}</li>
          <li parentName="ul">{`full screen`}</li>
          <li parentName="ul">{`app windows`}</li>
        </ul>
      </li>
      <li parentName="ul">{`improved mouse integration`}</li>
    </ul>
    <h3 {...{
      "id": "1-install-required-packages",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#1-install-required-packages",
        "aria-label": "1 install required packages permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`1. Install required packages`}</h3>
    <p>{`Open the terminal and run the following command: `}</p>
    <p>{`If you are not sure how to open the terminal, please refer to the FAQ below.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`apt`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-y`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`bzip2`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`tar`}</span>{` build-essential`}</code></pre></div>
    <h3 {...{
      "id": "2--install-guest-additions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#2--install-guest-additions",
        "aria-label": "2  install guest additions permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`2.  Install Guest Additions`}</h3>
    <p>{`In order to install VirtualBox Guest Additions on your Ubuntu VM, use the menu to select `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Devices`}</code>{` `}{`→`}{` `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Insert Guest Additions CD image`}</code>{`.`}</p>
    <p>{`As soon as you attach the Guest Additions image to the VM, click on the CD icon in the menu bar, and then click the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Run Software`}</code>{` button in Files window.  You'll be prompted to enter you password.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d9d93408cc7562c688d17d1d11612ad6/0c1ff/vm-guest-additions-install.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADy0lEQVQ4y0XP609bdRgH8KMzm7hR6PX0Cr0A5aLMcin30glsM3uxM6HCHIPhnIhD1KmgOFzmXLdkTlzMMCMCApM4MvTMF77wHzAxxsRE0ShjG4ye0dJCS2/01/P7GpjRb/LJkzzJ8yRf5ski22Gj2fSDXCb9RqGQ83KlkleoVLxCxfJypYpXsiyvz8jgjWYzr2BZXs6yvIJV81qDgTdajLzBnMEbs0zfWqxZ3xtMGWVMqVIyeOqlDkx8NYWxsVHcnLqO6YkxjFz9DJPXPsf0+ChufDmCmevjmJkcx42RYdycGMUbLe2oSM1Gg8aGOnY39uqKUK3KP8LU6LI+mhoahgjESSJBINwjmJ8luPsnwYM7BIt/EQSWCPz3CdYEgr9/JViYJWNv9ZE8Rkma2XLSoXFutKtr8Dxb1sQcyJS5JwcvYlFYJl6vlwoeAfNzc5i/fRdLHgGzv/2OaDyOaHwDoXAE69EYNjPx8TWYmVTk7lBTR2q2eJgtQ7PG7mLSCurdF4cm4BOWiEcQaDweRyJJkQwsQoyugVAgkUhgc78pFgkD4fv4+vIXsDM6FKdk0uxHZaL9cS3q0y0upvNQo/vW1BQ8niXi8/loPBYFSSQQXhEQCfqxtrqKSDiMWDSCYCiE9WAQiYgf05+MwMmYUCfJpWU79GLhY3LkbZe6mGqbzT08dBXLXh8JeJfpnUAYPwth/LIcwR8rEfy4sIq5QAQ/CWHEw+uIRKJblWcGx/DsthxwskK6f5dFdKboYE9RuphtDOMe6O2HsPyAzM/fpoFgCN61dQj+VfjWQvCsrMIfDEHwBxGPxbZqb+bWlXE0bs9DG1tEW2T5YlO6GfvT9C5mJ/OI+1z/GQTXQ+TewgLdPIKYhEgIkoT8P5MEhBBsxDe2Hn43OIq2JwpwUmenXerd4ivqPLSqzC5GK1G4D2ZV4cOqF0l/eSvtLX+B9lUeoe9VHaXvV7fR0zXtdOA/bfSDmqP0rLONvvvUAfqmpoz2Guy0X28TB3T5eD3D6mLUUsX5ytRsdOyq3OiUOsVuWZ3YKa0Vj6dVi8fTq8UTUse/asSXpdVil6xK7JGXi+9oK8QBY6V4LrM0eT63glyw1+JMZo6LybfkXHJqCtEoKUGzvBzHVA68qm3Aa7p96NbtRbf+oR59A04Z6tGX+QxOm5w4a67BBUsFLltK8GlhBa449uCSJauFycu2WovZnKbandaDDkku50i1cg6JldsnLeQOKUsfUpVyTaoSrlldzLVqbNwx7dPcCX0h15VRwPUY87m3DVlcv1r73EmLSf0PM7lYquM0JI4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-guest-additions-install",
            "title": "vm-guest-additions-install",
            "src": "/static/d9d93408cc7562c688d17d1d11612ad6/fcda8/vm-guest-additions-install.png",
            "srcSet": ["/static/d9d93408cc7562c688d17d1d11612ad6/12f09/vm-guest-additions-install.png 148w", "/static/d9d93408cc7562c688d17d1d11612ad6/e4a3f/vm-guest-additions-install.png 295w", "/static/d9d93408cc7562c688d17d1d11612ad6/fcda8/vm-guest-additions-install.png 590w", "/static/d9d93408cc7562c688d17d1d11612ad6/efc66/vm-guest-additions-install.png 885w", "/static/d9d93408cc7562c688d17d1d11612ad6/c83ae/vm-guest-additions-install.png 1180w", "/static/d9d93408cc7562c688d17d1d11612ad6/0c1ff/vm-guest-additions-install.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Press `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Return`}</code>{` key to complete the installation.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/bc8bb1b23b341427b3d627694f37ad1d/0c1ff/vm-guest-additions-install-complete.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADEklEQVQ4y2VRy27bRhRl6ixqW04syyJlUnxIfOllUiIlkZTEty3JiS3JhgnHKFoUyD5ZpED3QatNF/2TVqsu+mUNWM4tZtwEBbo4OHPOvbivoXqm8dgxBn82RPE3pdHY/RdNSdrJkrTrttu7vnG+01VlJwnCrimKJIb5Kd76XVeUP5qS5FAG3/g1NlUQmyLURR7YOgssz8FZnQWhIYKiK6C0NOgaPdA7LWiqMjSUJkhyA2RVBl4SQG1pxOdF/htqyeo/vbf64Er9v2aClbuckbusQXgm2nmqunmiunksj/OwMcpTzSMa5wbSMJ+JVu5x5iePM8GsavdU6gbb7zcPkHLjfM6MUVTuwwU9hEtmBOmpDfHJAMKXBkwO2jArdcHbb8P0oAPTwy5h/+gc+aVegbW5J2XURqtvP3pNCLhRvtFiNK87sOBdWAoeLMUJ+GUDoqoF0ekALtgxJIwNUXUAaW0IwYmJNfKPzwvvqAOX6iSjhPHNtpP9ABFj5ms1RrjQlTiBV9KMIKr0IWWGkNAWpLURzDkHEtqGi9qINJmUOsg9aBVhpQ+PyW1G9exg2wtvIWHtPK5auBtMX/TAPzYIZi97EJRNwD5mXAT7eLqgbIB32EbufqvA+iFcZdTV1N8+vrqGlB/nV8IEXQkTuGTHsKi7sOA9wvO6C9j/rBd154uX1kZoetQlBbPpdUbdLVfbH999gJi18znnINw1xLehbTLN7EWP3CuuDoiPV4vxTSt9PB1MSl00KXUK/8SAe1wwnfrbt99+Bxe8k2fGEq3UkOC2laCVFqFF3UVrPUZ37RTdqBG6lgO01mJ0o4ToRvZRQtvIO2wXQcWEN+E6o3RG+tkWOxAxg08pPSziqlVEp4Mioa0irY2KhLaJ99kPK/0nPjFJLCibf0eVQX7JOfAQrDKqwyu/BMYY/FMDkqpFVsIfgNeNaQti2oaUscl6zn4LnIMWuP/C2de/vGfH53A/ff2GkhhO70navbxXW6vPzjbqV2cbdY/dKM9qG5liNgpVI9D22P/j+RNwbvtr4W6mj2r/AKtgaaGpEIezAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "vm-guest-additions-install-complete.png",
            "title": "vm-guest-additions-install-complete.png",
            "src": "/static/bc8bb1b23b341427b3d627694f37ad1d/fcda8/vm-guest-additions-install-complete.png",
            "srcSet": ["/static/bc8bb1b23b341427b3d627694f37ad1d/12f09/vm-guest-additions-install-complete.png 148w", "/static/bc8bb1b23b341427b3d627694f37ad1d/e4a3f/vm-guest-additions-install-complete.png 295w", "/static/bc8bb1b23b341427b3d627694f37ad1d/fcda8/vm-guest-additions-install-complete.png 590w", "/static/bc8bb1b23b341427b3d627694f37ad1d/efc66/vm-guest-additions-install-complete.png 885w", "/static/bc8bb1b23b341427b3d627694f37ad1d/c83ae/vm-guest-additions-install-complete.png 1180w", "/static/bc8bb1b23b341427b3d627694f37ad1d/0c1ff/vm-guest-additions-install-complete.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Reboot your VM. You may need to enter your password in order to restart the VM. `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`reboot`}</span></code></pre></div>
    <h2 {...{
      "id": "faq",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#faq",
        "aria-label": "faq permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`FAQ`}</h2>
    <h3 {...{
      "id": "how-do-i-open-the-terminal",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#how-do-i-open-the-terminal",
        "aria-label": "how do i open the terminal permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`How do I open the terminal?`}</em></h3>
    <p>{`Open the activity menu (The `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Show Apps`}</code>{` button at the bottom of the menu bar) , type `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`terminal`}</code>{`, and hit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Enter`}</code>{` key (or select the terminal icon).`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/493d458f718efe15892d8b42b7e2845c/0c1ff/faq-terminal-open.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACM0lEQVQ4y52Sz27TQBDG/QAtnBDEu/Xu7J/YG9SGJG2cpiGm0BLaCrVUCQR64VQJJCTuXJHFjQPvAT5x4MlASzxoN05a0R4Qh59mtfP5m9nxBGl/+2VvMPyhhPgKnBVSgAc4L6IoKgCgMA1TNJsbhda6YIwVnDMfJcy1dxvmW1zX3wXwNBi2O58nox3kwDCKIiSEYEgIChZhLAXWJWCsJK6bGI1WqIChBu6hlHi9lBIZY+58Fhzq9Y/vttuoYvUzSRIrhbAcwA7aG/Zp1rdHw77d67bt7uY9H/fTjn3c27Sj7S0ba2VBCAsAv0AI5JyPg2xnkL86HSOlay5RAgA6OAAyxpFzwHang8Msw26aotLa3zPOsdKWQogZeD2bBIcmzD/cZ0giZqVUpRCAQogl7jlZluF0OsWDgydojPFGLrcwBIALw1tbo5yevMU1Elq2RpcdLj5wsdVqYX+nj2naxTiOl/cVvkN39oathwf58Owctda22XtQuo4WQ3ZRKeXRWvu4KOjyFSVjbMa5Gw+fBEej/fz9m3NUum6b/Ucu6RL+79Xrdf/ExCRoGgbjJEYQ4POU0gUlpXTmNsQbttNOfjI9RRKGNqJhWVXyXfhulcJF145Ls7t+his3buYrq6vOxEopy2omnkp8hcuaKzOE2u1PQEIUnLldmol5NU8lvBa40P0W812cG473dr+8fvEcjZjvnlubv570zzDGpsHxRtJ4lnYmitSOa4SckP/ntFar3fkDeANT28eFHHsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "faq-terminal-open",
            "title": "faq-terminal-open",
            "src": "/static/493d458f718efe15892d8b42b7e2845c/fcda8/faq-terminal-open.png",
            "srcSet": ["/static/493d458f718efe15892d8b42b7e2845c/12f09/faq-terminal-open.png 148w", "/static/493d458f718efe15892d8b42b7e2845c/e4a3f/faq-terminal-open.png 295w", "/static/493d458f718efe15892d8b42b7e2845c/fcda8/faq-terminal-open.png 590w", "/static/493d458f718efe15892d8b42b7e2845c/efc66/faq-terminal-open.png 885w", "/static/493d458f718efe15892d8b42b7e2845c/c83ae/faq-terminal-open.png 1180w", "/static/493d458f718efe15892d8b42b7e2845c/0c1ff/faq-terminal-open.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <h3 {...{
      "id": "how-do-i-copy-and-paste-in-ubuntu",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#how-do-i-copy-and-paste-in-ubuntu",
        "aria-label": "how do i copy and paste in ubuntu permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`How do I copy and paste in Ubuntu?`}</em></h3>
    <p>{`The keyboard shortcuts for copying and pasting differ depending on whether there are executed within the terminal elsewhere.`}</p>
    <h4 {...{
      "id": "terminal",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#terminal",
        "aria-label": "terminal permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Terminal`}</h4>
    <p>{`To copy text from the terminal/CLI prompt, use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`SHIFT+Ctrl+c`}</code>{`.  To past into the terminal, use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`SHIFT+Ctrl+v`}</code>{` `}</p>
    <h4 {...{
      "id": "everywhere-else",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#everywhere-else",
        "aria-label": "everywhere else permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Everywhere else`}</h4>
    <p>{`To copy text elsewhere (VM's web browser, code editor, etc.), use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ctrl+c`}</code></p>
    <p>{`To paste text anywhere other than the terminal, use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ctrl+v`}</code>{`.`}</p>
    <h3 {...{
      "id": "how-do-i-copy-and-paste-from-host-to-guest-and-guest-to-host",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#how-do-i-copy-and-paste-from-host-to-guest-and-guest-to-host",
        "aria-label": "how do i copy and paste from host to guest and guest to host permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`How do I copy and paste from host to guest and guest to host?`}</em></h3>
    <p>{`To enable bidirectional copy / paste, you must first install `}<a parentName="p" {...{
        "href": "https://www.virtualbox.org/manual/ch04.html#guestadd-install",
        "target": "_self",
        "rel": "nofollow"
      }}>{`Guest Additions`}</a>{`.  From the VM menu, navigate to `}<strong parentName="p">{`Settings`}</strong>{` `}{`→`}{` `}<strong parentName="p">{`General`}</strong>{` `}{`→`}{` `}<strong parentName="p">{`Advanced`}</strong>{` and select `}<em parentName="p">{`Bidirectional`}</em>{` from the `}<strong parentName="p">{`Shared Clipboard`}</strong>{` dropdown.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e6631ebabcaf909954846174667712ce/8deec/setting-shared-clipboard.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.1891891891892%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACAElEQVQ4y62Ry27TQBSGZwESvECbolwAFdV2nMzNjsf38aRx0tYQlF7USrBArFmwZQOvxwap7dMA6TnITiqKgIpKLD79vzTnfDPSkDf26MFhvp15gTWmA2pGvm+UL4zyhEmjwOzqzLys9sxiXpndIjdppEwW/0oeq3GqPD20nj0kTvfpINk7+jaazNFkMQa+ROmN0PMV2o6L7pAhE17DwB2gY9vo9Ado9wdNrrqLLhO4veMI0nq05flnH5fRq0/oH74HFk0gSVLYnR2AF0QN0lfgBwpkNgOpKxhFGQRhAqM1QZSCH8bYe/wkIp12W0qVfPcijVQVV1QqyLMMFosFVFUFx8dHcHp6BrNqDsnJO4hff4Dx9ABm5QSmZdkwm07BFAX2ut2QdDodyehwydkQBRsCZxTDMMSynOKkLHF/fx8PqueoJzMs0giLNESd55hrjVprzHMNWheQJAl2r4Wc86UQArkQ0CTnyBhroDWUImcMuZAr+GpmTb0Ddf9dyHlzUPc/cUPyf4R/4Xbhv4puXLwWip9CRodf169bcs6v7gKlrP7QpaBuLVS10BcqRCklSiFWeQeiKEQZZkjDMXa7vZhsbmzsONnks+30Ly3LOrds+8KyrFux1zOO078weXJupy8u2+btl83WlksIIfcIIZuEkA4hpL3Ou3C90yKE3P8B0PxetO15TBMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "setting-shared-clipboard.png",
            "title": "setting-shared-clipboard.png",
            "src": "/static/e6631ebabcaf909954846174667712ce/fcda8/setting-shared-clipboard.png",
            "srcSet": ["/static/e6631ebabcaf909954846174667712ce/12f09/setting-shared-clipboard.png 148w", "/static/e6631ebabcaf909954846174667712ce/e4a3f/setting-shared-clipboard.png 295w", "/static/e6631ebabcaf909954846174667712ce/fcda8/setting-shared-clipboard.png 590w", "/static/e6631ebabcaf909954846174667712ce/efc66/setting-shared-clipboard.png 885w", "/static/e6631ebabcaf909954846174667712ce/c83ae/setting-shared-clipboard.png 1180w", "/static/e6631ebabcaf909954846174667712ce/8deec/setting-shared-clipboard.png 2136w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "how-do-i-restart-a-vm",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#how-do-i-restart-a-vm",
        "aria-label": "how do i restart a vm permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`How do I restart a VM?`}</em></h3>
    <p>{`If your VM is unresponsive, you can force it to reset by right-clicking the entry for the VM in left pane of the VirtualBox window and selecting `}<strong parentName="p">{`Restart`}</strong>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e462d2c48d85cc59138660c9c158fc8b/a8a6f/faq-reset.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "87.83783783783784%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAABYlAAAWJQFJUiTwAAACwklEQVQ4y3WUW2/aQBCF/TdS5SlKWy4GbGPjxRfMGhtzs7gmQKhaqY9VVPX/v5zqDDUiJH0YrT3r+fbMZW2kqwT+ZImosNGLXKwyDzpyEYYR8lyj2AwwzjKM8wyjVKPnuf+1oK9g5JsjnNNvJN+/wh428eepi3JkIQwTeIGF6KUOs2nCNE20WiYsqwPH6cJxHNi2/ca63S4MXR4wWR6R7V6RbF/hlr/QyX9ADQvMZgtkeoqBzpFmOWKdQQUxOq0m2u0OLMt6A/Q8D0ay/o71y08ksyWKxRpBksHyAnQ9H2EUQ4UxPD9AGMdwe+rsH81QFAV8378oq6DGbL5AzbRgWTZ8z4XqeXC7NmzLguu6iKMIqdYoFwuM0hSOY2P/8g3H4xHrzQar9RrL5RKn0wnT6RRGmhWSQq/Xw1BrOY3GGhFIU/2+7Ff+w2GPx8dH1Gs1tM0mHh4eEEURdrsdjL5S6HQ6CIJATqrqwlUphcFggCRJJL12uy3+zWaD+/t7AdW+fManuzuJYbxBED9iQdM0lZXBokwphGGI7XaL8XgsPh7OdM1WG8puI/K6qNUbSFMtBxn9fl+ATIUAwq6LTFVMl9/wmTaZTPC83+Pw9ITj/hnb3Q6Hw0EyESBPZdBisUBZlsjzHFEcg3tU3Wq15DmOYwHzvdlsot5ooF5voCFrXfYuQCrjKDAtaYBzHofVaiXQ+XwunazUfzTY9AmweiGIcCrw/80aa3jptlKSMvfPN6d1KQPj3gCrztLJtZjOZAxYaK211IfraDQSy7JMRoWK2cgPFVZGYJRPZAyGw6H4CCOkgrHO3COUe8xAbso1sFoJTPOxTD6VMZgBTPPWmHaV+juF18B8fr5SVMThphKmxjoTzm+u7V0Nb4GjWSkKOfgcFxrVMk02ioBbOwPjgfwIboF6XMhMEkAYVV13tFJ1bfwf/gVpdlhn+Zju8wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "faq-reset",
            "title": "faq-reset",
            "src": "/static/e462d2c48d85cc59138660c9c158fc8b/fcda8/faq-reset.png",
            "srcSet": ["/static/e462d2c48d85cc59138660c9c158fc8b/12f09/faq-reset.png 148w", "/static/e462d2c48d85cc59138660c9c158fc8b/e4a3f/faq-reset.png 295w", "/static/e462d2c48d85cc59138660c9c158fc8b/fcda8/faq-reset.png 590w", "/static/e462d2c48d85cc59138660c9c158fc8b/efc66/faq-reset.png 885w", "/static/e462d2c48d85cc59138660c9c158fc8b/c83ae/faq-reset.png 1180w", "/static/e462d2c48d85cc59138660c9c158fc8b/a8a6f/faq-reset.png 1516w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <div {...{
      "className": "admonition admonition-warning alert alert--danger"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "12",
              "height": "16",
              "viewBox": "0 0 12 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M5.05.31c.81 2.17.41 3.38-.52 4.31C3.55 5.67 1.98 6.45.9 7.98c-1.45 2.05-1.7 6.53 3.53 7.7-2.2-1.16-2.67-4.52-.3-6.61-.61 2.03.53 3.33 1.94 2.86 1.39-.47 2.3.53 2.27 1.67-.02.78-.31 1.44-1.13 1.81 3.42-.59 4.78-3.42 4.78-5.56 0-2.84-2.53-3.22-1.25-5.61-1.52.13-2.03 1.13-1.89 2.75.09 1.08-1.02 1.8-1.86 1.33-.67-.41-.66-1.19-.06-1.78C8.18 5.31 8.68 2.45 5.05.32L5.03.3l.02.01z"
              }}></path></svg></span>{`Pulling the plug`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`From your VM's perspective, this is equivalent to `}<strong parentName="p">{`unplugging the power from your computer.`}</strong></p></div></div>
    <h3 {...{
      "id": "how-do-i-shut-down-a-vm",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#how-do-i-shut-down-a-vm",
        "aria-label": "how do i shut down a vm permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`How do I shut down a VM?`}</em></h3>
    <p>{`If you are running an Ubuntu LTS VM, click the power icon in the upper righthand corner of your screen, click the power icon that appears,  and select `}<strong parentName="p">{`Power Off`}</strong>{` `}{`→`}{`  `}<strong parentName="p">{`Power Off`}</strong>{`. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/476d4e49ca37ad74bfb9f1db984fa2e7/0c1ff/faq-shutdown.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.54054054054055%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAADyElEQVQ4yzXO20+bdQDG8TeZ2ZZyhsJ6GLS0lALtWlgZpRvQsh5oKYW3wFvoCOeDbBScovNA4mFAy6EMGPNCvRCj2WQjWm+MFMUbYUEvdSDGMA7hsIQ/wOX1/T2mDV588tx981BqrcabpykIS+XSbzIVmSFpljRKEiGXhDKzZSFlnjKUm6MMZUolIaFQEBKdEgouhC6KRSHd5YJv8/O13yuUCj2lSZdOX9dkQ84TIpeXDlVsBjRxUuTHy6BLzIIuTgaTXIcGdz3cDhdqKpyosVfBaXPAZXeCdrjQ09qJ7uZ2OIpMTZRdrBwZyNdCf0b2j/lMLltxVs1Wndey7pjLrCdBzzLndOxAsYf98uFX7Befz7MLXy+wi4uL7JPHT6L76OEjdn5+/uVnn3yKgdr2espiMPpbqz0wvJLFWs+piJ2ngSu2AO54HZhkPep5OvgMDJ7+to6NZxvY2NzA5uYmdnZ2sLu7G1lyfHzMrf6yigazi6HcynT/sEGGa2dzWCdPS6qjsUIwiUXwplxFY8wVvHatAb9vPouGIpG9vb2o/f39yJLjFy+4p2trqDbZGEpcWOmXu/phPZ/D0rE6Eol5korhTTagVWhEK78Ub5lb8MefG/hrawvPt7ejsUj4/4dHR0fc2uoq6sodDFVsqvJXNvXDzlOz9QlFhEkoQovQiG6pFf151ehILcPb1jZs/b2Fne3n0VdHh4c4PHVwcEBOTk64X9fX4TU7GarWZvcP3fKhMkbLepMM5EbkWVop+nNduK2i0Se1Y8jRie/CS/hhKYzw8jLCKz9jaflHLIfDCIfD5KeVFe7xwgK6HG6GKtUb/E2eBtTEFbDNKSWkhV+CNn4peiU2DGRXwZdRgXetHZgeaEewthxBtxFBjxXBux9g1B/AyPAwCQQC3NTEJN6ovcFQ8iSRPyfhIppTS9gOfhlpSy0jnWkm0i0oJ70iC+lJLiN3TC1kZrCLjDEWMuG1k6kWF5kLjpHg7CyZvDdFpmdnuNm5+3jH08xQ8hTxqDo1Ez1C88tBsZPzCW3cTYGF6xWYuZsiC9fLN3Fv6hu58bEpbuTDAOcfnuDGR4PcTGCSezAW5B6MB//9+N4MOzcawJCzjqFUGYpJk7YY7iQd2vmleFVwHT6hFX1CK26d6hNbcVvmwKDcjjtZNryXbcH7SjPu5pQjkGfEZL4JM5cM+EihaaQkaSKlWpJdfzVeUWOMU9Jl8UranKiia/g62p165VQh7U7Q0nWJGrox+RLdlKKm2/gquistl+69oKR9aXL6dbG8tiddJvgPmAYEnY7UwRYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "faq-shutdown",
            "title": "faq-shutdown",
            "src": "/static/476d4e49ca37ad74bfb9f1db984fa2e7/fcda8/faq-shutdown.png",
            "srcSet": ["/static/476d4e49ca37ad74bfb9f1db984fa2e7/12f09/faq-shutdown.png 148w", "/static/476d4e49ca37ad74bfb9f1db984fa2e7/e4a3f/faq-shutdown.png 295w", "/static/476d4e49ca37ad74bfb9f1db984fa2e7/fcda8/faq-shutdown.png 590w", "/static/476d4e49ca37ad74bfb9f1db984fa2e7/efc66/faq-shutdown.png 885w", "/static/476d4e49ca37ad74bfb9f1db984fa2e7/c83ae/faq-shutdown.png 1180w", "/static/476d4e49ca37ad74bfb9f1db984fa2e7/0c1ff/faq-shutdown.png 2192w"],
            "sizes": "(max-width: 590px) 100vw, 590px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{` `}</p>
    <h1 {...{
      "id": "next-steps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#next-steps",
        "aria-label": "next steps permalink",
        "className": "md-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "height": "20",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "20"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Next Steps`}</h1>
    <p>{`For an introduction to the Linux command line, `}<a parentName="p" {...{
        "href": "/tutorials/linux-command-line-basics"
      }}>{`see this tutorial`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      